import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import zhTW from 'antd/locale/zh_TW';
import koKR from 'antd/locale/ko_KR';
import jaJP from 'antd/locale/ja_JP';
import frFR from 'antd/locale/fr_FR';
import esES from 'antd/locale/es_ES';
import {AppLocale} from './i18n.types';

type MessageCatalog = Record<string, string>;

export const appMessages: Record<AppLocale, MessageCatalog> = {
    'zh-CN': {
        'app.lang.zh-CN': '简中',
        'app.lang.zh-TW': '繁中',
        'app.lang.en-US': 'EN',
        'app.lang.ko-KR': '한국어',
        'app.lang.ja-JP': '日本語',
        'app.lang.fr-FR': 'Français',
        'app.lang.es-ES': 'Español',
        'site.brand.subtitle': '交易员的AI资产管家',
        'site.header.drawerTitle': '站点导航',
        'site.header.resource': '资源',
        'site.footer.navigation': '站点导航',
        'site.footer.risk': '风险声明',
        'site.footer.riskText': '仅用于交易辅助，不构成投资建议，也不承诺收益。',
        'site.footer.bottomLeft': '© 2026 D-Sense AI Quant',
        'site.footer.bottomRight': '邀请码注册，逐步开放',
        'site.announcement.label': '最新动态',
        'site.announcement.action': '查看',
        'site.announcement.fallback': '当前官网已切换为 AI 量化产品叙事，体验申请继续采用邀请码制。',
        'site.splitShowcase.panel': '展示面板',
        'site.splitShowcase.structured': '结构化表达',
        'site.pocTradingView.title': '交易工作台',
        'site.pocTradingView.subtitle': '实时数据展示，操作已禁用',
        'site.pocTradingView.notice': '展示交易工作台实时数据，下单、平仓、撤单等操作已禁用。完整功能请在登录后访问交易页面。',
        'site.pocTradingView.noConnection': '暂无全局展示连接配置',
        'site.pocTradingView.loadError': '加载交易数据失败，请稍后重试',
        'site.pocTradingView.errorTitle': '加载失败',
        'site.pocTradingView.retry': '重试',
        'site.pocBotView.title': 'AI自动交易工作台',
        'site.pocBotView.subtitle': '实时交互演示',
        'site.pocBotView.notice': '展示AI自动交易完整流程。选择API Key、设定偏好、生成Prompt、查看决策历史。',
        'site.risk.ruleLabel': '风控守则',
        'site.contactPanel.eyebrow': '获取邀请码',
        'site.contactPanel.title': '没有邀请码，就先提交信息',
        'site.contactPanel.description': '有邀请码可直接注册，没有邀请码可先提交信息。',
        'site.contactPanel.email': '邮箱',
        'site.contactPanel.startPath': '开始方式',
        'site.contactPanel.startPathValue': '提交信息 → 获取邀请码 → 注册账户 → 登录系统',
        'site.contactPanel.audience': '适用对象',
        'site.contactPanel.audienceValue': '适合希望减少盯盘、提高判断效率的个人交易者',
        'site.contactPanel.name': '姓名',
        'site.contactPanel.namePlaceholder': '请输入姓名',
        'site.contactPanel.contact': '联系方式',
        'site.contactPanel.contactPlaceholder': '请输入手机号或邮箱',
        'site.contactPanel.experience': '交易经验',
        'site.contactPanel.experiencePlaceholder': '请简单说明交易经验和使用场景',
        'site.contactPanel.focus': '关注方向',
        'site.contactPanel.focusPlaceholder': '请选择关注方向',
        'site.contactPanel.focus.ai': 'AI 分析能力',
        'site.contactPanel.focus.trade': '自动交易执行',
        'site.contactPanel.focus.risk': '风险控制与资产视图',
        'site.contactPanel.note': '补充说明',
        'site.contactPanel.notePlaceholder': '请说明你最想用的功能和当前习惯',
        'site.contactPanel.invite': '获取邀请码',
        'site.contactPanel.register': '立即注册',
        'site.contactPanel.login': '去登录',
        'site.contactModal.title': '联系我们',
        'site.contactModal.label.name': '称呼',
        'site.contactModal.label.email': '联系邮箱',
        'site.contactModal.label.phone': '联系电话',
        'site.contactModal.label.subject': '主题',
        'site.contactModal.label.content': '内容',
        'site.contactModal.placeholder.name': '您的称呼',
        'site.contactModal.placeholder.email': '联系邮箱',
        'site.contactModal.placeholder.phone': '联系电话（选填）',
        'site.contactModal.placeholder.subject': '请选择咨询主题',
        'site.contactModal.placeholder.content': '请输入您想咨询的内容',
        'site.contactModal.rule.name': '请输入您的称呼',
        'site.contactModal.rule.email': '请输入联系邮箱',
        'site.contactModal.rule.emailType': '请输入有效的邮箱地址',
        'site.contactModal.rule.subject': '请选择咨询主题',
        'site.contactModal.rule.content': '请输入咨询内容',
        'site.contactModal.subject.product': '产品咨询',
        'site.contactModal.subject.cooperation': '合作意向',
        'site.contactModal.subject.tech': '技术问题',
        'site.contactModal.subject.feedback': '意见反馈',
        'site.contactModal.subject.other': '其他',
        'site.contactModal.okText': '提交',
        'site.contactModal.cancelText': '取消',
        'site.contactModal.success': '提交成功，我们会尽快与您联系',
        'site.contactModal.fail': '提交失败，请稍后重试',
        'site.waitlistModal.title': '获取邀请码',
        'site.waitlistModal.placeholder.name': '您的名称',
        'site.waitlistModal.placeholder.email': '联系邮箱',
        'site.waitlistModal.placeholder.direction': '感兴趣的方向',
        'site.waitlistModal.rule.name': '请输入您的名称',
        'site.waitlistModal.rule.email': '请输入有效的邮箱地址',
        'site.waitlistModal.rule.emailType': '请输入有效的邮箱地址',
        'site.waitlistModal.rule.direction': '请选择应用方向',
        'site.waitlistModal.okText': '提交申请',
        'site.waitlistModal.cancelText': '取消',
        'site.waitlistModal.success': '申请已提交，我们会尽快与您联系',
        'site.waitlistModal.fail': '提交失败，请稍后重试',
        'site.waitlistModal.direction.assist': 'AI 辅助交易',
        'site.waitlistModal.direction.auto': '自动化交易',
        'site.waitlistModal.direction.asset': '资产管理',
        'site.waitlistModal.direction.risk': '风控管理',
        'site.waitlistModal.direction.other': '其他',
        'auth.login.actionHome': '返回官网',
        'auth.login.eyebrow': '交易工作台',
        'auth.login.title': '登录你的 D-Sense 账户',
        'auth.login.panelTitle': '欢迎回来',
        'auth.login.description': '登录后查看你的策略表现、资产概览与执行记录。',
        'auth.login.footnote': '已有账户可直接登录，尚未获得邀请码？',
        'auth.login.cardTitle': '账户登录',
        'auth.login.cardDescription': '登录后继续使用系统。',
        'auth.login.usernameRequired': '请输入用户名',
        'auth.login.passwordRequired': '请输入密码',
        'auth.login.passwordMin': '密码至少 6 位',
        'auth.login.usernamePlaceholder': '用户名',
        'auth.login.passwordPlaceholder': '密码',
        'auth.login.submit': '登录',
        'auth.login.noAccount': '还没有账号？',
        'auth.login.register': '邀请码注册',
        'auth.login.getInvite': '获取邀请码',
        'auth.login.alreadyLoggedIn': '已检测到登录状态',
        'auth.login.enterSystem': '进入系统',
        'auth.login.highlight.1.title': '次世代资管服务',
        'auth.login.highlight.1.description': '登录后开启AI资产管理服务',
        'auth.login.highlight.2.title': '用户测试进行中',
        'auth.login.highlight.2.description': '登录即用，开启您的交易之旅',
        'auth.login.highlight.3.title': '风险警示',
        'auth.login.highlight.3.description': 'D-sense是AI资产管家，不承诺任何收益。',
        'auth.register.actionPoc': '查看 POC',
        'auth.register.eyebrow': '开始使用',
        'auth.register.title': '注册你的 D-Sense 账户',
        'auth.register.description': '填写邀请码和账户信息后即可开始。',
        'auth.register.footnote': '有邀请码可直接注册，没有邀请码先获取。',
        'auth.register.cardTitle': '邀请码注册',
        'auth.register.cardDescription': '输入邀请码后即可注册。',
        'auth.register.step.verify': '验证邀请码',
        'auth.register.step.verifyDescription': '输入您的邀请码',
        'auth.register.step.create': '填写信息',
        'auth.register.step.createDescription': '创建您的账户',
        'auth.register.enterCode': '请输入邀请码',
        'auth.register.codeLabel': '邀请码',
        'auth.register.codePlaceholder': '请输入邀请码',
        'auth.register.codeSubmit': '验证邀请码',
        'auth.register.codeEmpty': '请输入邀请码',
        'auth.register.codeFailed': '验证失败，请稍后重试',
        'auth.register.usernameRequired': '请输入用户名',
        'auth.register.usernameMin': '用户名至少 3 位',
        'auth.register.usernameMax': '用户名最多 50 位',
        'auth.register.usernamePlaceholder': '用户名（3-50 位）',
        'auth.register.emailRequired': '请输入邮箱',
        'auth.register.emailInvalid': '请输入有效的邮箱地址',
        'auth.register.emailPlaceholder': '邮箱',
        'auth.register.passwordRequired': '请输入密码',
        'auth.register.passwordMin': '密码至少 6 位',
        'auth.register.passwordPlaceholder': '密码（至少 6 位）',
        'auth.register.confirmRequired': '请确认密码',
        'auth.register.confirmPlaceholder': '确认密码',
        'auth.register.confirmMismatch': '两次输入的密码不一致',
        'auth.register.previous': '上一步',
        'auth.register.submit': '注册',
        'auth.register.existing': '已有账户？',
        'auth.register.login': '登录',
        'auth.register.getInvite': '获取邀请码',
        'auth.register.currentCode': '邀请码',
        'auth.register.highlight.1.title': '有邀请码即可开始',
        'auth.register.highlight.1.description': '填写邀请码后即可开始。',
        'auth.register.highlight.2.title': '注册流程更直接',
        'auth.register.highlight.2.description': '先验码，再注册。',
        'auth.register.highlight.3.title': '没有邀请码可先获取',
        'auth.register.highlight.3.description': '没有邀请码可先提交信息。',
        'membership.center.title': '会员中心',
        'membership.center.currentLevel': '当前等级',
        'membership.center.expireTime': '到期时间',
        'membership.center.noActive': '暂无生效订阅',
        'membership.center.dcaPlanLimit': 'DCA 助手计划上限',
        'membership.center.renewGuide': '续费/开通请联系运营（第一期人工开通）',
        'membership.center.contact': '联系运营',
        'membership.center.history': '订阅历史',
        'membership.center.history.empty': '暂无订阅记录',
        'membership.center.compare': '等级与功能对比',
        'membership.center.amount': '金额 (USDT)',
        'membership.center.startTime': '生效时间',
        'membership.center.openMethod': '开通方式',
        'membership.center.remark': '备注',
        'membership.center.level': '等级',
        'membership.center.period': '周期',
        'membership.level.0': '免费',
        'membership.level.1': '初级',
        'membership.level.2': '专业',
        'membership.level.3': '专家',
        'membership.period.MONTHLY': '月付',
        'membership.period.YEARLY': '年付',
        'membership.period.TRIAL': '14天试用',
        'membership.openMethod.MANUAL': '人工开通',
        'membership.openMethod.TRIAL': '注册试用',
        'membership.pricing.monthly': '月付价格',
        'membership.pricing.yearlyMonthly': '年付折合月价',
        'membership.feature.reports': '订阅/观看报告',
        'membership.feature.dca': 'DCA助手',
        'membership.feature.hedge': '对冲交易',
        'membership.feature.pattern': '形态识别快捷交易',
        'membership.feature.autoTrading': '自动交易',
        'membership.upgrade.title': '升级会员',
        'membership.upgrade.need': '该功能需要「{level}」及以上等级',
        'membership.upgrade.desc': '升级后可解锁以下功能；开通请联系运营。',
        'membership.upgrade.back': '返回首页',
        'membership.load.error': '会员信息加载失败',
        'dca.page.title': 'DCA 助手',
        'dca.common.cancel': '取消',
        'dca.common.ok': '确定',
        'dca.page.desc': '计划式条件交易：满足条件自动市价买入现货',
        'dca.page.create': '创建计划',
        'dca.page.settings': 'DCA 设置',
        'dca.page.empty': '暂无 DCA 计划，点击「创建计划」开始',
        'dca.page.loadError': '计划列表加载失败',
        'dca.page.configLoadError': 'DCA 设置加载失败',
        'dca.page.createNeedSymbols': '暂无可选品种，请先在「DCA 设置」中配置可选品种',
        'dca.page.myPlans': '我的计划',
        'dca.page.tabCalculator': '计算器',
        'dca.page.tabRunning': '运行中的计划',
        'dca.page.noRunningPlans': '暂无运行中的计划',
        'dca.calc.stats': '统计',
        'dca.calc.chart': '图表',
        'dca.calc.reset': '重置',
        'dca.calc.amount': '金额',
        'dca.calc.frequency': '频率',
        'dca.calc.conditions': '条件',
        'dca.calc.conditionSummary': '{op} · {n} 条',
        'dca.calc.currentValue': '当前价值',
        'dca.calc.invested': '已投资',
        'dca.calc.calculate': '计算',
        'dca.calc.calculating': '计算中…',
        'dca.calc.noResult': '设置参数后点击「计算」查看回测效果',
        'dca.calc.amountRequired': '请输入大于 0 的买入金额',
        'dca.calc.amountSaveFail': '买入金额保存失败',
        'dca.calc.rangeInvalid': '开始时间必须早于结束时间',
        'dca.calc.rangeFuture': '结束时间不能晚于当前时间',
        'dca.calc.rangeMaxDays': '{tf} 周期回测范围最多 {days} 天',
        'dca.calc.chartLoading': 'K线加载中…',
        'dca.calc.chartEmpty': '暂无K线数据',
        'dca.calc.createFromResult': '按此配置创建计划',
        'dca.calc.buyPoint': '买入点',
        'dca.calc.maxBuyCount': '触发上限',
        'dca.calc.start': '开始',
        'dca.calc.end': '结束',
        'dca.plan.status.ACTIVE': '运行中',
        'dca.plan.status.PAUSED': '已暂停',
        'dca.plan.status.STOPPED': '已停止',
        'dca.plan.status.COMPLETED': '已完成',
        'dca.plan.lifecycle.ONCE': '单次',
        'dca.plan.lifecycle.LOOP': '循环',
        'dca.plan.signal': '信号状态',
        'dca.plan.signal.0': '未触发',
        'dca.plan.signal.1': '已触发',
        'dca.plan.blockTag': '无法执行',
        'dca.plan.block.NO_API_ACCOUNT': '未绑定可用的 API 连接',
        'dca.plan.bought': '已买 {bought}/{max} 次',
        'dca.plan.buyProgress': '已买/上限',
        'dca.plan.lastChecked': '上次监控',
        'dca.plan.never': '从未监控',
        'dca.plan.detail': '详情',
        'dca.plan.edit': '编辑',
        'dca.plan.pause': '暂停',
        'dca.plan.resume': '恢复',
        'dca.plan.stop': '停止',
        'dca.plan.delete': '删除',
        'dca.plan.pauseConfirm': '确认暂停该计划？暂停后不再监控。',
        'dca.plan.stopConfirm': '停止为终态操作不可恢复，确认停止该计划？',
        'dca.plan.deleteConfirm': '确认删除该计划？（执行流水仍保留）',
        'dca.plan.opOk': '操作成功',
        'dca.plan.opFail': '操作失败',
        'dca.form.title.create': '创建 DCA 计划',
        'dca.form.title.edit': '编辑 DCA 计划',
        'dca.form.planName': '计划名称',
        'dca.form.planNamePlaceholder': '如：BTC 定投计划',
        'dca.form.planNameRequired': '请输入计划名称',
        'dca.form.planNameMax': '计划名称最多 64 字符',
        'dca.form.symbol': '交易品种',
        'dca.form.symbolRequired': '请选择交易品种',
        'dca.form.symbolEmpty': '暂无可选品种，请先在「DCA 设置」中配置',
        'dca.form.lifecycle': '触发模式',
        'dca.form.lifecycle.onceTip': '触发一次后计划自动完成',
        'dca.form.lifecycle.loopTip': '反复触发买入，直至次数上限',
        'dca.form.timeframe': 'K线周期',
        'dca.form.timeframeRequired': '请选择K线周期',
        'dca.form.monitorFrequency': '监控频率（分钟）',
        'dca.form.monitorFrequencyRequired': '监控频率需在 1~1440 之间',
        'dca.form.monitorFrequencyUnit': '分钟',
        'dca.form.unlimited': '不限',
        'dca.form.maxBuyCount': '循环买入次数上限',
        'dca.form.maxBuyCountRequired': '请输入循环买入次数上限',
        'dca.form.dailyMaxTriggers': '单日触发次数上限',
        'dca.form.dailyMaxTriggersPlaceholder': '留空不限',
        'dca.form.dailyMaxTriggersPlaceholderEdit': '留空保持不变',
        'dca.form.conditions': '触发条件',
        'dca.form.conditionsTip': '监控已收盘K线，满足条件组合即触发自动买入（1~5 条）',
        'dca.form.op': '组合关系',
        'dca.form.op.AND': '全部满足 (AND)',
        'dca.form.op.OR': '任一满足 (OR)',
        'dca.form.add': '添加条件',
        'dca.form.maxReached': '最多 5 条条件',
        'dca.form.conditionEmpty': '至少添加 1 条条件',
        'dca.form.condParams': '参数',
        'dca.form.remove': '删除',
        'dca.form.paramInvalid': '该条件参数不完整或不合法',
        'dca.form.preview': '条件预览',
        'dca.form.previewEmpty': '--',
        'dca.form.risk': '风险确认',
        'dca.form.riskText': '我已知晓：满足条件后系统将自动市价买入现货，存在亏损风险，平台不承诺收益。',
        'dca.form.riskRequired': '创建计划必须勾选风险确认',
        'dca.form.submit': '创建计划',
        'dca.form.save': '保存修改',
        'dca.form.saveOk': '保存成功',
        'dca.form.saveFail': '保存失败',
        'dca.cond.EMA_CROSS': 'EMA 快慢线关系',
        'dca.cond.PRICE_CROSS_EMA': '价格与 EMA 关系',
        'dca.cond.SMA_CROSS': 'SMA 快慢线关系',
        'dca.cond.RSI': 'RSI 与阈值关系',
        'dca.cond.MACD_CROSS': 'MACD DIF/DEA 关系',
        'dca.cond.PRICE_BELOW': '价格低于指定值',
        'dca.cond.DRAWDOWN': '区间回撤',
        'dca.cond.LOW_TOUCH': '触及前N根最低价',
        'dca.cond.fast': '快线周期',
        'dca.cond.slow': '慢线周期',
        'dca.cond.period': '周期',
        'dca.cond.dir': '方向',
        'dca.cond.mode': '比较方式',
        'dca.cond.mode.CROSS_UP': '高于',
        'dca.cond.mode.CROSS_DOWN': '低于',
        'dca.cond.level': '阈值',
        'dca.cond.value': '价格',
        'dca.cond.windowMin': '窗口（分钟）',
        'dca.cond.pct': '回撤（%）',
        'dca.cond.periods': '根数',
        'dca.cond.range': '须在 [{min}, {max}] 之间',
        'dca.cond.rsilevel': '须在 (0, 100) 之间',
        'dca.cond.pctRange': '须在 (0, 100) 之间',
        'dca.cond.windowMinMin': '须 ≥ 60',
        'dca.cond.valuePositive': '须大于 0',
        'dca.preview.and': '同时满足以下条件：',
        'dca.preview.or': '满足以下任一条件：',
        'dca.preview.EMA_CROSS': 'EMA 快线{fast} {dir} 慢线{slow}',
        'dca.preview.PRICE_CROSS_EMA': '价格{dir} EMA{period}',
        'dca.preview.SMA_CROSS': 'SMA 快线{fast} {dir} 慢线{slow}',
        'dca.preview.RSI': 'RSI{period} {mode} {level}',
        'dca.preview.MACD_CROSS': 'MACD DIF {dir} DEA（12/26/9）',
        'dca.preview.PRICE_BELOW': '收盘价低于 {value}',
        'dca.preview.DRAWDOWN': '近{windowMin}分钟回撤超 {pct}%',
        'dca.preview.LOW_TOUCH': '触及前{periods}根K线最低价',
        'dca.dir.golden': '高于',
        'dca.dir.death': '低于',
        'dca.dir.crossUp': '高于',
        'dca.dir.crossDown': '低于',
        'dca.detail.title': '计划详情',
        'dca.detail.basic': '基本信息',
        'dca.detail.conditions': '触发条件',
        'dca.detail.executions': '执行流水',
        'dca.detail.execEmpty': '暂无执行记录',
        'dca.detail.time': '触发时间',
        'dca.detail.status': '状态',
        'dca.detail.amount': '金额 (U)',
        'dca.detail.fill': '成交',
        'dca.detail.avgPx': '成交均价',
        'dca.detail.reason': '原因',
        'dca.detail.snapshot': '条件快照',
        'dca.detail.dryRun': '模拟',
        'dca.detail.exec.EXECUTING': '执行中',
        'dca.detail.exec.SUCCESS': '成功',
        'dca.detail.exec.FAILED': '失败',
        'dca.detail.riskConfirmedAt': '风险确认时间',
        'dca.detail.blockReason': '无法执行原因',
        'dca.detail.createdAt': '创建时间',
        'dca.detail.updatedAt': '更新时间',
        'dca.detail.loadExecError': '执行流水加载失败',
        'dca.cost.title': '成本追踪',
        'dca.cost.quantity': '累计买入量',
        'dca.cost.amount': '累计买入金额 (U)',
        'dca.cost.avgCost': '平均成本',
        'dca.cost.currentPrice': '现价',
        'dca.cost.pnl': '浮盈亏 (U)',
        'dca.cost.loadError': '成本数据加载失败',
        'dca.settings.title': 'DCA 设置',
        'dca.settings.amount': '单次买入金额 (USDT)',
        'dca.settings.amountRequired': '买入金额须大于 0',
        'dca.settings.notify': '通知策略',
        'dca.settings.notify.EVERY': '每次触发都通知',
        'dca.settings.notify.DAILY_SUMMARY': '成功每日汇总，失败即时',
        'dca.settings.notify.OFF': '关闭通知',
        'dca.settings.dailyLimit': '单日买入总额上限 (USDT)',
        'dca.settings.dailyLimitPlaceholder': '留空=按平台上限',
        'dca.settings.platformLimitTip': '平台硬上限：单次 {amount} U / 单日总额 {daily} U / 单计划买入 {count} 次 / 单日触发 {triggers} 次。留空或超出均按平台上限执行',
        'dca.settings.visible': '可见品种',
        'dca.settings.visibleTip': '须为系统白名单子集；收窄将自动暂停受影响计划',
        'dca.settings.allowed': '可选品种（可建计划）',
        'dca.settings.allowedTip': '须为可见品种子集；空=不可创建新计划',
        'dca.settings.noGlobal': '系统暂未配置可用品种',
        'dca.settings.save': '保存设置',
        'dca.settings.saveOk': '设置已保存',
        'dca.settings.saveFail': '设置保存失败',
        'dca.settings.loading': '正在加载配置…',
        'dca.settings.configNotLoaded': '配置尚未加载完成，无法保存',
        'dca.resume.title': '恢复计划',
        'dca.resume.riskText': '该计划尚未完成风险确认。恢复后系统将按条件自动市价买入现货，请确认已了解自动下单风险。',
        'dca.resume.confirm': '确认恢复',
        'dca.plan.backtest': '测算',
        'dca.form.backtest': '测算',
        'dca.backtest.title': '测算历史效果',
        'dca.backtest.rangeDays': '回测范围',
        'dca.backtest.run': '开始测算',
        'dca.backtest.running': '测算中…',
        'dca.backtest.amountTip': '每次触发买入金额按您 DCA 设置的 {amount} U 模拟',
        'dca.backtest.range.7': '最近 7 天',
        'dca.backtest.range.30': '最近 30 天',
        'dca.backtest.range.90': '最近 90 天',
        'dca.backtest.rangeInfo': '回测区间',
        'dca.backtest.klineCount': 'K线数量',
        'dca.backtest.stats.triggers': '触发次数',
        'dca.backtest.stats.quantity': '累计买入量',
        'dca.backtest.stats.amount': '累计投入',
        'dca.backtest.stats.avgCost': '平均成本',
        'dca.backtest.stats.latestPrice': '最新价',
        'dca.backtest.stats.pnl': '浮盈亏',
        'dca.backtest.stats.maxDrawdown': '期间最大回撤',
        'dca.backtest.list': '触发明细',
        'dca.backtest.list.time': '触发时间',
        'dca.backtest.list.price': '价格',
        'dca.backtest.list.amount': '金额',
        'dca.backtest.list.quantity': '币量',
        'dca.backtest.empty': '该区间内未触发任何买入',
        'dca.backtest.error': '测算失败'
    },
    'zh-TW': {
        'app.lang.zh-CN': '簡中',
        'app.lang.zh-TW': '繁中',
        'app.lang.en-US': 'EN',
        'app.lang.ko-KR': '한국어',
        'app.lang.ja-JP': '日本語',
        'app.lang.fr-FR': 'Français',
        'app.lang.es-ES': 'Español',
        'site.brand.subtitle': '交易员的AI資產管家',
        'site.header.drawerTitle': '站點導航',
        'site.header.resource': '資源',
        'site.footer.navigation': '站點導航',
        'site.footer.risk': '風險聲明',
        'site.footer.riskText': '僅用於交易輔助，不構成投資建議，也不承諾收益。',
        'site.footer.bottomLeft': '© 2026 D-Sense AI Quant',
        'site.footer.bottomRight': '邀請碼註冊，逐步開放',
        'site.announcement.label': '最新動態',
        'site.announcement.action': '查看',
        'site.announcement.fallback': '目前官網已切換為 AI 量化產品敘事，體驗申請仍採用邀請碼制。',
        'site.splitShowcase.panel': '展示面板',
        'site.splitShowcase.structured': '結構化表達',
        'site.pocTradingView.title': '交易工作台',
        'site.pocTradingView.subtitle': '即時數據展示，操作已禁用',
        'site.pocTradingView.notice': '展示交易工作台即時數據，下單、平倉、撤單等操作已禁用。完整功能請在登錄後訪問交易頁面。',
        'site.pocTradingView.noConnection': '暫無全局展示連接配置',
        'site.pocTradingView.loadError': '加載交易數據失敗，請稍後重試',
        'site.pocTradingView.errorTitle': '加載失敗',
        'site.pocTradingView.retry': '重試',
        'site.pocBotView.title': 'AI自動交易工作台',
        'site.pocBotView.subtitle': '即時互動展示',
        'site.pocBotView.notice': '展示AI自動交易完整流程。選擇API Key、設定偏好、生成Prompt、檢視決策歷史。',
        'site.risk.ruleLabel': '風控守則',
        'site.contactPanel.eyebrow': '獲取邀請碼',
        'site.contactPanel.title': '沒有邀請碼，就先提交資訊',
        'site.contactPanel.description': '有邀請碼可直接註冊，沒有邀請碼可先提交資訊。',
        'site.contactPanel.email': '郵箱',
        'site.contactPanel.startPath': '開始方式',
        'site.contactPanel.startPathValue': '提交資訊 → 獲取邀請碼 → 註冊帳戶 → 登錄系統',
        'site.contactPanel.audience': '適用對象',
        'site.contactPanel.audienceValue': '適合希望減少盯盤、提高判斷效率的個人交易者',
        'site.contactPanel.name': '姓名',
        'site.contactPanel.namePlaceholder': '請輸入姓名',
        'site.contactPanel.contact': '聯絡方式',
        'site.contactPanel.contactPlaceholder': '請輸入手機號或郵箱',
        'site.contactPanel.experience': '交易經驗',
        'site.contactPanel.experiencePlaceholder': '請簡單說明交易經驗與使用場景',
        'site.contactPanel.focus': '關注方向',
        'site.contactPanel.focusPlaceholder': '請選擇關注方向',
        'site.contactPanel.focus.ai': 'AI 分析能力',
        'site.contactPanel.focus.trade': '自動交易執行',
        'site.contactPanel.focus.risk': '風險控制與資產視圖',
        'site.contactPanel.note': '補充說明',
        'site.contactPanel.notePlaceholder': '請說明你最想用的功能與目前習慣',
        'site.contactPanel.invite': '獲取邀請碼',
        'site.contactPanel.register': '立即註冊',
        'site.contactPanel.login': '去登錄',
        'site.contactModal.title': '聯絡我們',
        'site.contactModal.label.name': '稱呼',
        'site.contactModal.label.email': '聯絡郵箱',
        'site.contactModal.label.phone': '聯絡電話',
        'site.contactModal.label.subject': '主題',
        'site.contactModal.label.content': '內容',
        'site.contactModal.placeholder.name': '您的稱呼',
        'site.contactModal.placeholder.email': '聯絡郵箱',
        'site.contactModal.placeholder.phone': '聯絡電話（選填）',
        'site.contactModal.placeholder.subject': '請選擇諮詢主題',
        'site.contactModal.placeholder.content': '請輸入您想諮詢的內容',
        'site.contactModal.rule.name': '請輸入您的稱呼',
        'site.contactModal.rule.email': '請輸入聯絡郵箱',
        'site.contactModal.rule.emailType': '請輸入有效的郵箱地址',
        'site.contactModal.rule.subject': '請選擇諮詢主題',
        'site.contactModal.rule.content': '請輸入諮詢內容',
        'site.contactModal.subject.product': '產品諮詢',
        'site.contactModal.subject.cooperation': '合作意向',
        'site.contactModal.subject.tech': '技術問題',
        'site.contactModal.subject.feedback': '意見反饋',
        'site.contactModal.subject.other': '其他',
        'site.contactModal.okText': '提交',
        'site.contactModal.cancelText': '取消',
        'site.contactModal.success': '提交成功，我們會盡快與您聯繫',
        'site.contactModal.fail': '提交失敗，請稍後重試',
        'site.waitlistModal.title': '獲取邀請碼',
        'site.waitlistModal.placeholder.name': '您的名稱',
        'site.waitlistModal.placeholder.email': '聯絡郵箱',
        'site.waitlistModal.placeholder.direction': '感興趣的方向',
        'site.waitlistModal.rule.name': '請輸入您的名稱',
        'site.waitlistModal.rule.email': '請輸入有效的郵箱地址',
        'site.waitlistModal.rule.emailType': '請輸入有效的郵箱地址',
        'site.waitlistModal.rule.direction': '請選擇應用方向',
        'site.waitlistModal.okText': '提交申請',
        'site.waitlistModal.cancelText': '取消',
        'site.waitlistModal.success': '申請已提交，我們會盡快與您聯繫',
        'site.waitlistModal.fail': '提交失敗，請稍後重試',
        'site.waitlistModal.direction.assist': 'AI 輔助交易',
        'site.waitlistModal.direction.auto': '自動化交易',
        'site.waitlistModal.direction.asset': '資產管理',
        'site.waitlistModal.direction.risk': '風控管理',
        'site.waitlistModal.direction.other': '其他',
        'auth.login.actionHome': '返回官網',
        'auth.login.eyebrow': '交易工作台',
        'auth.login.title': '登入你的 D-Sense 帳戶',
        'auth.login.panelTitle': '歡迎回來',
        'auth.login.description': '登入後查看你的策略表現、資產概覽與執行記錄。',
        'auth.login.footnote': '已有帳戶可直接登入，尚未獲得邀請碼？',
        'auth.login.cardTitle': '帳戶登入',
        'auth.login.cardDescription': '登入後繼續使用系統。',
        'auth.login.usernameRequired': '請輸入使用者名稱',
        'auth.login.passwordRequired': '請輸入密碼',
        'auth.login.passwordMin': '密碼至少 6 位',
        'auth.login.usernamePlaceholder': '使用者名稱',
        'auth.login.passwordPlaceholder': '密碼',
        'auth.login.submit': '登入',
        'auth.login.noAccount': '還沒有帳號？',
        'auth.login.register': '邀請碼註冊',
        'auth.login.getInvite': '獲取邀請碼',
        'auth.login.alreadyLoggedIn': '已檢測到登入狀態',
        'auth.login.enterSystem': '進入系統',
        'auth.login.highlight.1.title': '次世代資管服務',
        'auth.login.highlight.1.description': '登入後開啟AI資產管理服務',
        'auth.login.highlight.2.title': '我們正在進行小規模用戶測試',
        'auth.login.highlight.2.description': '登入即用，開啟您的交易之旅',
        'auth.login.highlight.3.title': '風險警示',
        'auth.login.highlight.3.description': 'D-sense是AI資產管家，不承諾任何收益。',
        'auth.register.actionPoc': '查看 POC',
        'auth.register.eyebrow': '開始使用',
        'auth.register.title': '註冊你的 D-Sense 帳戶',
        'auth.register.description': '填寫邀請碼與帳戶資訊後即可開始。',
        'auth.register.footnote': '有邀請碼可直接註冊，沒有邀請碼可先獲取。',
        'auth.register.cardTitle': '邀請碼註冊',
        'auth.register.cardDescription': '輸入邀請碼後即可註冊。',
        'auth.register.step.verify': '驗證邀請碼',
        'auth.register.step.verifyDescription': '輸入你的邀請碼',
        'auth.register.step.create': '填寫資訊',
        'auth.register.step.createDescription': '建立你的帳戶',
        'auth.register.enterCode': '請輸入邀請碼',
        'auth.register.codeLabel': '邀請碼',
        'auth.register.codePlaceholder': '請輸入邀請碼',
        'auth.register.codeSubmit': '驗證邀請碼',
        'auth.register.codeEmpty': '請輸入邀請碼',
        'auth.register.codeFailed': '驗證失敗，請稍後重試',
        'auth.register.usernameRequired': '請輸入使用者名稱',
        'auth.register.usernameMin': '使用者名稱至少 3 位',
        'auth.register.usernameMax': '使用者名稱最多 50 位',
        'auth.register.usernamePlaceholder': '使用者名稱（3-50 位）',
        'auth.register.emailRequired': '請輸入郵箱',
        'auth.register.emailInvalid': '請輸入有效的郵箱地址',
        'auth.register.emailPlaceholder': '郵箱',
        'auth.register.passwordRequired': '請輸入密碼',
        'auth.register.passwordMin': '密碼至少 6 位',
        'auth.register.passwordPlaceholder': '密碼（至少 6 位）',
        'auth.register.confirmRequired': '請確認密碼',
        'auth.register.confirmPlaceholder': '確認密碼',
        'auth.register.confirmMismatch': '兩次輸入的密碼不一致',
        'auth.register.previous': '上一步',
        'auth.register.submit': '註冊',
        'auth.register.existing': '已有帳戶？',
        'auth.register.login': '登入',
        'auth.register.getInvite': '獲取邀請碼',
        'auth.register.currentCode': '邀請碼',
        'auth.register.highlight.1.title': '有邀請碼即可開始',
        'auth.register.highlight.1.description': '填寫邀請碼後即可開始。',
        'auth.register.highlight.2.title': '註冊流程更直接',
        'auth.register.highlight.2.description': '先驗碼，再註冊。',
        'auth.register.highlight.3.title': '沒有邀請碼可先獲取',
        'auth.register.highlight.3.description': '沒有邀請碼可先提交資訊。',
        'membership.center.title': '會員中心',
        'membership.center.currentLevel': '目前等級',
        'membership.center.expireTime': '到期時間',
        'membership.center.noActive': '暫無生效訂閱',
        'membership.center.dcaPlanLimit': 'DCA 助手計畫上限',
        'membership.center.renewGuide': '續費/開通請聯繫營運（第一期人工開通）',
        'membership.center.contact': '聯繫營運',
        'membership.center.history': '訂閱歷史',
        'membership.center.history.empty': '暫無訂閱記錄',
        'membership.center.compare': '等級與功能對比',
        'membership.center.amount': '金額 (USDT)',
        'membership.center.startTime': '生效時間',
        'membership.center.openMethod': '開通方式',
        'membership.center.remark': '備註',
        'membership.center.level': '等級',
        'membership.center.period': '週期',
        'membership.level.0': '免費',
        'membership.level.1': '初級',
        'membership.level.2': '專業',
        'membership.level.3': '專家',
        'membership.period.MONTHLY': '月付',
        'membership.period.YEARLY': '年付',
        'membership.period.TRIAL': '14天試用',
        'membership.openMethod.MANUAL': '人工開通',
        'membership.openMethod.TRIAL': '註冊試用',
        'membership.pricing.monthly': '月付價格',
        'membership.pricing.yearlyMonthly': '年付折合月價',
        'membership.feature.reports': '訂閱/觀看報告',
        'membership.feature.dca': 'DCA助手',
        'membership.feature.hedge': '對沖交易',
        'membership.feature.pattern': '型態辨識快捷交易',
        'membership.feature.autoTrading': '自動交易',
        'membership.upgrade.title': '升級會員',
        'membership.upgrade.need': '該功能需要「{level}」及以上等級',
        'membership.upgrade.desc': '升級後可解鎖以下功能；開通請聯繫營運。',
        'membership.upgrade.back': '返回首頁',
        'membership.load.error': '會員資訊載入失敗',
        'dca.page.title': 'DCA 助手',
        'dca.common.cancel': '取消',
        'dca.common.ok': '確定',
        'dca.page.desc': '計劃式條件交易：滿足條件自動市價買入現貨',
        'dca.page.create': '建立計劃',
        'dca.page.settings': 'DCA 設定',
        'dca.page.empty': '暫無 DCA 計劃，點擊「建立計劃」開始',
        'dca.page.loadError': '計劃列表載入失敗',
        'dca.page.configLoadError': 'DCA 設定載入失敗',
        'dca.page.createNeedSymbols': '暫無可選品種，請先在「DCA 設定」中配置可選品種',
        'dca.page.myPlans': '我的計畫',
        'dca.page.tabCalculator': '計算器',
        'dca.page.tabRunning': '運行中的計畫',
        'dca.page.noRunningPlans': '暫無運行中的計畫',
        'dca.calc.stats': '統計',
        'dca.calc.chart': '圖表',
        'dca.calc.reset': '重置',
        'dca.calc.amount': '金額',
        'dca.calc.frequency': '頻率',
        'dca.calc.conditions': '條件',
        'dca.calc.conditionSummary': '{op} · {n} 條',
        'dca.calc.currentValue': '目前價值',
        'dca.calc.invested': '已投資',
        'dca.calc.calculate': '計算',
        'dca.calc.calculating': '計算中…',
        'dca.calc.noResult': '設定參數後點擊「計算」查看回測效果',
        'dca.calc.amountRequired': '請輸入大於 0 的買入金額',
        'dca.calc.amountSaveFail': '買入金額儲存失敗',
        'dca.calc.rangeInvalid': '開始時間必須早於結束時間',
        'dca.calc.rangeFuture': '結束時間不能晚於目前時間',
        'dca.calc.rangeMaxDays': '{tf} 週期回測範圍最多 {days} 天',
        'dca.calc.chartLoading': 'K線載入中…',
        'dca.calc.chartEmpty': '暫無K線資料',
        'dca.calc.createFromResult': '按此配置建立計畫',
        'dca.calc.buyPoint': '買入點',
        'dca.calc.maxBuyCount': '觸發上限',
        'dca.calc.start': '開始',
        'dca.calc.end': '結束',
        'dca.plan.status.ACTIVE': '運行中',
        'dca.plan.status.PAUSED': '已暫停',
        'dca.plan.status.STOPPED': '已停止',
        'dca.plan.status.COMPLETED': '已完成',
        'dca.plan.lifecycle.ONCE': '單次',
        'dca.plan.lifecycle.LOOP': '循環',
        'dca.plan.signal': '訊號狀態',
        'dca.plan.signal.0': '未觸發',
        'dca.plan.signal.1': '已觸發',
        'dca.plan.blockTag': '無法執行',
        'dca.plan.block.NO_API_ACCOUNT': '未綁定可用的 API 連線',
        'dca.plan.bought': '已買 {bought}/{max} 次',
        'dca.plan.buyProgress': '已買/上限',
        'dca.plan.lastChecked': '上次監控',
        'dca.plan.never': '從未監控',
        'dca.plan.detail': '詳情',
        'dca.plan.edit': '編輯',
        'dca.plan.pause': '暫停',
        'dca.plan.resume': '恢復',
        'dca.plan.stop': '停止',
        'dca.plan.delete': '刪除',
        'dca.plan.pauseConfirm': '確認暫停該計劃？暫停後不再監控。',
        'dca.plan.stopConfirm': '停止為終態操作不可恢復，確認停止該計劃？',
        'dca.plan.deleteConfirm': '確認刪除該計劃？（執行流水仍保留）',
        'dca.plan.opOk': '操作成功',
        'dca.plan.opFail': '操作失敗',
        'dca.form.title.create': '建立 DCA 計劃',
        'dca.form.title.edit': '編輯 DCA 計劃',
        'dca.form.planName': '計劃名稱',
        'dca.form.planNamePlaceholder': '如：BTC 定投計劃',
        'dca.form.planNameRequired': '請輸入計劃名稱',
        'dca.form.planNameMax': '計劃名稱最多 64 字元',
        'dca.form.symbol': '交易品種',
        'dca.form.symbolRequired': '請選擇交易品種',
        'dca.form.symbolEmpty': '暫無可選品種，請先在「DCA 設定」中配置',
        'dca.form.lifecycle': '觸發模式',
        'dca.form.lifecycle.onceTip': '觸發一次後計劃自動完成',
        'dca.form.lifecycle.loopTip': '反覆觸發買入，直至次數上限',
        'dca.form.timeframe': 'K線週期',
        'dca.form.timeframeRequired': '請選擇K線週期',
        'dca.form.monitorFrequency': '監控頻率（分鐘）',
        'dca.form.monitorFrequencyRequired': '監控頻率需在 1~1440 之間',
        'dca.form.monitorFrequencyUnit': '分鐘',
        'dca.form.unlimited': '不限',
        'dca.form.maxBuyCount': '循環買入次數上限',
        'dca.form.maxBuyCountRequired': '請輸入循環買入次數上限',
        'dca.form.dailyMaxTriggers': '單日觸發次數上限',
        'dca.form.dailyMaxTriggersPlaceholder': '留空不限',
        'dca.form.dailyMaxTriggersPlaceholderEdit': '留空保持不變',
        'dca.form.conditions': '觸發條件',
        'dca.form.conditionsTip': '監控已收盤K線，滿足條件組合即觸發自動買入（1~5 條）',
        'dca.form.op': '組合關係',
        'dca.form.op.AND': '全部滿足 (AND)',
        'dca.form.op.OR': '任一滿足 (OR)',
        'dca.form.add': '新增條件',
        'dca.form.maxReached': '最多 5 條條件',
        'dca.form.conditionEmpty': '至少新增 1 條條件',
        'dca.form.condParams': '參數',
        'dca.form.remove': '刪除',
        'dca.form.paramInvalid': '該條件參數不完整或不合法',
        'dca.form.preview': '條件預覽',
        'dca.form.previewEmpty': '--',
        'dca.form.risk': '風險確認',
        'dca.form.riskText': '我已知曉：滿足條件後系統將自動市價買入現貨，存在虧損風險，平台不承諾收益。',
        'dca.form.riskRequired': '建立計劃必須勾選風險確認',
        'dca.form.submit': '建立計劃',
        'dca.form.save': '儲存修改',
        'dca.form.saveOk': '儲存成功',
        'dca.form.saveFail': '儲存失敗',
        'dca.cond.EMA_CROSS': 'EMA 快慢線關係',
        'dca.cond.PRICE_CROSS_EMA': '價格與 EMA 關係',
        'dca.cond.SMA_CROSS': 'SMA 快慢線關係',
        'dca.cond.RSI': 'RSI 與閾值關係',
        'dca.cond.MACD_CROSS': 'MACD DIF/DEA 關係',
        'dca.cond.PRICE_BELOW': '價格低於指定值',
        'dca.cond.DRAWDOWN': '區間回撤',
        'dca.cond.LOW_TOUCH': '觸及前N根最低價',
        'dca.cond.fast': '快線週期',
        'dca.cond.slow': '慢線週期',
        'dca.cond.period': '週期',
        'dca.cond.dir': '方向',
        'dca.cond.mode': '比較方式',
        'dca.cond.mode.CROSS_UP': '高於',
        'dca.cond.mode.CROSS_DOWN': '低於',
        'dca.cond.level': '閾值',
        'dca.cond.value': '價格',
        'dca.cond.windowMin': '窗口（分鐘）',
        'dca.cond.pct': '回撤（%）',
        'dca.cond.periods': '根數',
        'dca.cond.range': '須在 [{min}, {max}] 之間',
        'dca.cond.rsilevel': '須在 (0, 100) 之間',
        'dca.cond.pctRange': '須在 (0, 100) 之間',
        'dca.cond.windowMinMin': '須 ≥ 60',
        'dca.cond.valuePositive': '須大於 0',
        'dca.preview.and': '同時滿足以下條件：',
        'dca.preview.or': '滿足以下任一條件：',
        'dca.preview.EMA_CROSS': 'EMA 快線{fast} {dir} 慢線{slow}',
        'dca.preview.PRICE_CROSS_EMA': '價格{dir} EMA{period}',
        'dca.preview.SMA_CROSS': 'SMA 快線{fast} {dir} 慢線{slow}',
        'dca.preview.RSI': 'RSI{period} {mode} {level}',
        'dca.preview.MACD_CROSS': 'MACD DIF {dir} DEA（12/26/9）',
        'dca.preview.PRICE_BELOW': '收盤價低於 {value}',
        'dca.preview.DRAWDOWN': '近{windowMin}分鐘回撤超 {pct}%',
        'dca.preview.LOW_TOUCH': '觸及前{periods}根K線最低價',
        'dca.dir.golden': '高於',
        'dca.dir.death': '低於',
        'dca.dir.crossUp': '高於',
        'dca.dir.crossDown': '低於',
        'dca.detail.title': '計劃詳情',
        'dca.detail.basic': '基本資訊',
        'dca.detail.conditions': '觸發條件',
        'dca.detail.executions': '執行流水',
        'dca.detail.execEmpty': '暫無執行記錄',
        'dca.detail.time': '觸發時間',
        'dca.detail.status': '狀態',
        'dca.detail.amount': '金額 (U)',
        'dca.detail.fill': '成交',
        'dca.detail.avgPx': '成交均價',
        'dca.detail.reason': '原因',
        'dca.detail.snapshot': '條件快照',
        'dca.detail.dryRun': '模擬',
        'dca.detail.exec.EXECUTING': '執行中',
        'dca.detail.exec.SUCCESS': '成功',
        'dca.detail.exec.FAILED': '失敗',
        'dca.detail.riskConfirmedAt': '風險確認時間',
        'dca.detail.blockReason': '無法執行原因',
        'dca.detail.createdAt': '建立時間',
        'dca.detail.updatedAt': '更新時間',
        'dca.detail.loadExecError': '執行流水載入失敗',
        'dca.cost.title': '成本追蹤',
        'dca.cost.quantity': '累計買入量',
        'dca.cost.amount': '累計買入金額 (U)',
        'dca.cost.avgCost': '平均成本',
        'dca.cost.currentPrice': '現價',
        'dca.cost.pnl': '浮盈虧 (U)',
        'dca.cost.loadError': '成本資料載入失敗',
        'dca.settings.title': 'DCA 設定',
        'dca.settings.amount': '單次買入金額 (USDT)',
        'dca.settings.amountRequired': '買入金額須大於 0',
        'dca.settings.notify': '通知策略',
        'dca.settings.notify.EVERY': '每次觸發都通知',
        'dca.settings.notify.DAILY_SUMMARY': '成功每日彙總，失敗即時',
        'dca.settings.notify.OFF': '關閉通知',
        'dca.settings.dailyLimit': '單日買入總額上限 (USDT)',
        'dca.settings.dailyLimitPlaceholder': '留空=按平台上限',
        'dca.settings.platformLimitTip': '平台硬上限：單次 {amount} U / 單日總額 {daily} U / 單計劃買入 {count} 次 / 單日觸發 {triggers} 次。留空或超出均按平台上限執行',
        'dca.settings.visible': '可見品種',
        'dca.settings.visibleTip': '須為系統白名單子集；收窄將自動暫停受影響計劃',
        'dca.settings.allowed': '可選品種（可建計劃）',
        'dca.settings.allowedTip': '須為可見品種子集；空=不可建立新計劃',
        'dca.settings.noGlobal': '系統暫未配置可用品種',
        'dca.settings.save': '儲存設定',
        'dca.settings.saveOk': '設定已儲存',
        'dca.settings.saveFail': '設定儲存失敗',
        'dca.settings.loading': '正在載入配置…',
        'dca.settings.configNotLoaded': '配置尚未載入完成，無法儲存',
        'dca.resume.title': '恢復計劃',
        'dca.resume.riskText': '該計劃尚未完成風險確認。恢復後系統將按條件自動市價買入現貨，請確認已了解自動下單風險。',
        'dca.resume.confirm': '確認恢復',
        'dca.plan.backtest': '測算',
        'dca.form.backtest': '測算',
        'dca.backtest.title': '測算歷史效果',
        'dca.backtest.rangeDays': '回測範圍',
        'dca.backtest.run': '開始測算',
        'dca.backtest.running': '測算中…',
        'dca.backtest.amountTip': '每次觸發買入金額按您 DCA 設定的 {amount} U 模擬',
        'dca.backtest.range.7': '最近 7 天',
        'dca.backtest.range.30': '最近 30 天',
        'dca.backtest.range.90': '最近 90 天',
        'dca.backtest.rangeInfo': '回測區間',
        'dca.backtest.klineCount': 'K線數量',
        'dca.backtest.stats.triggers': '觸發次數',
        'dca.backtest.stats.quantity': '累計買入量',
        'dca.backtest.stats.amount': '累計投入',
        'dca.backtest.stats.avgCost': '平均成本',
        'dca.backtest.stats.latestPrice': '最新價',
        'dca.backtest.stats.pnl': '浮盈虧',
        'dca.backtest.stats.maxDrawdown': '期間最大回撤',
        'dca.backtest.list': '觸發明細',
        'dca.backtest.list.time': '觸發時間',
        'dca.backtest.list.price': '價格',
        'dca.backtest.list.amount': '金額',
        'dca.backtest.list.quantity': '幣量',
        'dca.backtest.empty': '該區間內未觸發任何買入',
        'dca.backtest.error': '測算失敗'
    },
    'en-US': {
        'app.lang.zh-CN': 'SC',
        'app.lang.zh-TW': 'TC',
        'app.lang.en-US': 'EN',
        'app.lang.ko-KR': 'KO',
        'app.lang.ja-JP': 'JA',
        'app.lang.fr-FR': 'FR',
        'app.lang.es-ES': 'ES',
        'site.brand.subtitle': 'AI Asset Steward for Traders',
        'site.header.drawerTitle': 'Site Navigation',
        'site.header.resource': 'Resources',
        'site.footer.navigation': 'Navigation',
        'site.footer.risk': 'Risk Notice',
        'site.footer.riskText': 'For trading assistance only. It is not investment advice and does not promise returns.',
        'site.footer.bottomLeft': '© 2026 D-Sense AI Quant',
        'site.footer.bottomRight': 'Invitation-code access, rolling out gradually',
        'site.announcement.label': 'Latest',
        'site.announcement.action': 'View',
        'site.announcement.fallback': 'The website now focuses on the AI trading product narrative, and trial access still uses invitation codes.',
        'site.splitShowcase.panel': 'Showcase',
        'site.splitShowcase.structured': 'Structured Output',
        'site.pocTradingView.title': 'Trading Workspace',
        'site.pocTradingView.subtitle': 'Real-time data display, trading disabled',
        'site.pocTradingView.notice': 'Display real-time trading data. Placing orders, closing positions, and canceling orders are disabled. Please log in and visit the trading page for full functionality.',
        'site.pocTradingView.noConnection': 'No global display connection configured',
        'site.pocTradingView.loadError': 'Failed to load trading data. Please try again later.',
        'site.pocTradingView.errorTitle': 'Loading Failed',
        'site.pocTradingView.retry': 'Retry',
        'site.pocBotView.title': 'AI Auto-Trading Workspace',
        'site.pocBotView.subtitle': 'Interactive demo',
        'site.pocBotView.notice': 'Demonstrates the complete AI auto-trading workflow. Select API Key, set preferences, generate prompts, and view decision history.',
        'site.risk.ruleLabel': 'Risk Rule',
        'site.contactPanel.eyebrow': 'Get an Invitation Code',
        'site.contactPanel.title': 'No code yet? Share your info first',
        'site.contactPanel.description': 'If you already have an invitation code, you can register now. Otherwise, leave your information first.',
        'site.contactPanel.email': 'Email',
        'site.contactPanel.startPath': 'How to Start',
        'site.contactPanel.startPathValue': 'Submit info → Receive code → Register account → Log in',
        'site.contactPanel.audience': 'Best For',
        'site.contactPanel.audienceValue': 'Individual traders who want less screen-watching and more decision efficiency',
        'site.contactPanel.name': 'Name',
        'site.contactPanel.namePlaceholder': 'Enter your name',
        'site.contactPanel.contact': 'Contact',
        'site.contactPanel.contactPlaceholder': 'Enter your phone number or email',
        'site.contactPanel.experience': 'Trading Experience',
        'site.contactPanel.experiencePlaceholder': 'Briefly describe your trading experience and use case',
        'site.contactPanel.focus': 'Focus Area',
        'site.contactPanel.focusPlaceholder': 'Select a focus area',
        'site.contactPanel.focus.ai': 'AI analysis',
        'site.contactPanel.focus.trade': 'Automated execution',
        'site.contactPanel.focus.risk': 'Risk control and asset view',
        'site.contactPanel.note': 'Additional Notes',
        'site.contactPanel.notePlaceholder': 'Tell us the features you care about most and your current workflow',
        'site.contactPanel.invite': 'Get Invite Code',
        'site.contactPanel.register': 'Register Now',
        'site.contactPanel.login': 'Go to Login',
        'site.contactModal.title': 'Contact Us',
        'site.contactModal.label.name': 'Name',
        'site.contactModal.label.email': 'Contact Email',
        'site.contactModal.label.phone': 'Phone',
        'site.contactModal.label.subject': 'Subject',
        'site.contactModal.label.content': 'Message',
        'site.contactModal.placeholder.name': 'Your Name',
        'site.contactModal.placeholder.email': 'Contact Email',
        'site.contactModal.placeholder.phone': 'Phone (Optional)',
        'site.contactModal.placeholder.subject': 'Please select a subject',
        'site.contactModal.placeholder.content': 'Please enter your message',
        'site.contactModal.rule.name': 'Please enter your name',
        'site.contactModal.rule.email': 'Please enter your email',
        'site.contactModal.rule.emailType': 'Please enter a valid email address',
        'site.contactModal.rule.subject': 'Please select a subject',
        'site.contactModal.rule.content': 'Please enter your message',
        'site.contactModal.subject.product': 'Product Inquiry',
        'site.contactModal.subject.cooperation': 'Partnership',
        'site.contactModal.subject.tech': 'Technical Issue',
        'site.contactModal.subject.feedback': 'Feedback',
        'site.contactModal.subject.other': 'Other',
        'site.contactModal.okText': 'Submit',
        'site.contactModal.cancelText': 'Cancel',
        'site.contactModal.success': 'Submitted successfully, we will contact you soon',
        'site.contactModal.fail': 'Submission failed, please try again later',
        'site.waitlistModal.title': 'Get an Invitation Code',
        'site.waitlistModal.placeholder.name': 'Your Name',
        'site.waitlistModal.placeholder.email': 'Contact Email',
        'site.waitlistModal.placeholder.direction': 'Area of Interest',
        'site.waitlistModal.rule.name': 'Please enter your name',
        'site.waitlistModal.rule.email': 'Please enter a valid email address',
        'site.waitlistModal.rule.emailType': 'Please enter a valid email address',
        'site.waitlistModal.rule.direction': 'Please select an area of interest',
        'site.waitlistModal.okText': 'Submit Application',
        'site.waitlistModal.cancelText': 'Cancel',
        'site.waitlistModal.success': 'Application submitted, we will contact you soon',
        'site.waitlistModal.fail': 'Submission failed, please try again later',
        'site.waitlistModal.direction.assist': 'AI Assisted Trading',
        'site.waitlistModal.direction.auto': 'Automated Trading',
        'site.waitlistModal.direction.asset': 'Asset Management',
        'site.waitlistModal.direction.risk': 'Risk Control',
        'site.waitlistModal.direction.other': 'Other',
        'auth.login.actionHome': 'Back to Website',
        'auth.login.eyebrow': 'Trading Workspace',
        'auth.login.title': 'Sign in to your D-Sense account',
        'auth.login.panelTitle': 'Welcome back',
        'auth.login.description': 'View your strategy performance, asset overview, and execution records after signing in.',
        'auth.login.footnote': 'Already have an account? Sign in now. Don\'t have an invitation code yet?',
        'auth.login.cardTitle': 'Account Sign In',
        'auth.login.cardDescription': 'Sign in to continue using D-Sense.',
        'auth.login.usernameRequired': 'Please enter your username',
        'auth.login.passwordRequired': 'Please enter your password',
        'auth.login.passwordMin': 'Password must be at least 6 characters',
        'auth.login.usernamePlaceholder': 'Username',
        'auth.login.passwordPlaceholder': 'Password',
        'auth.login.submit': 'Sign In',
        'auth.login.noAccount': 'No account yet?',
        'auth.login.register': 'Register with invite',
        'auth.login.getInvite': 'Get an invite code',
        'auth.login.alreadyLoggedIn': 'Signed in as',
        'auth.login.enterSystem': 'Enter System',
        'auth.login.highlight.1.title': 'Next-gen asset management',
        'auth.login.highlight.1.description': 'Sign in to start AI-powered asset management',
        'auth.login.highlight.2.title': 'We\'re running a small-scale user test',
        'auth.login.highlight.2.description': 'Sign in and start your trading journey',
        'auth.login.highlight.3.title': 'Risk Warning',
        'auth.login.highlight.3.description': 'D-sense is an AI asset manager and does not promise any returns.',
        'auth.register.actionPoc': 'View POC',
        'auth.register.eyebrow': 'Get Started',
        'auth.register.title': 'Create your D-Sense account',
        'auth.register.description': 'Enter your invitation code and account details to get started.',
        'auth.register.footnote': 'Have a code? Register now. Need one first? Apply for access.',
        'auth.register.cardTitle': 'Invitation Registration',
        'auth.register.cardDescription': 'Enter a valid invitation code to create your account.',
        'auth.register.step.verify': 'Verify Code',
        'auth.register.step.verifyDescription': 'Enter your invitation code',
        'auth.register.step.create': 'Create Account',
        'auth.register.step.createDescription': 'Fill in your account details',
        'auth.register.enterCode': 'Enter your invitation code',
        'auth.register.codeLabel': 'Invitation Code',
        'auth.register.codePlaceholder': 'Enter invitation code',
        'auth.register.codeSubmit': 'Verify Invitation Code',
        'auth.register.codeEmpty': 'Please enter your invitation code',
        'auth.register.codeFailed': 'Verification failed. Please try again later.',
        'auth.register.usernameRequired': 'Please enter your username',
        'auth.register.usernameMin': 'Username must be at least 3 characters',
        'auth.register.usernameMax': 'Username must be at most 50 characters',
        'auth.register.usernamePlaceholder': 'Username (3-50 characters)',
        'auth.register.emailRequired': 'Please enter your email',
        'auth.register.emailInvalid': 'Please enter a valid email address',
        'auth.register.emailPlaceholder': 'Email',
        'auth.register.passwordRequired': 'Please enter your password',
        'auth.register.passwordMin': 'Password must be at least 6 characters',
        'auth.register.passwordPlaceholder': 'Password (at least 6 characters)',
        'auth.register.confirmRequired': 'Please confirm your password',
        'auth.register.confirmPlaceholder': 'Confirm password',
        'auth.register.confirmMismatch': 'The two passwords do not match',
        'auth.register.previous': 'Previous',
        'auth.register.submit': 'Register',
        'auth.register.existing': 'Already have an account?',
        'auth.register.login': 'Sign in',
        'auth.register.getInvite': 'Get an invite code',
        'auth.register.currentCode': 'Invitation Code',
        'auth.register.highlight.1.title': 'Start with a valid code',
        'auth.register.highlight.1.description': 'Enter your invitation code to begin registration.',
        'auth.register.highlight.2.title': 'A shorter sign-up path',
        'auth.register.highlight.2.description': 'Verify first, then create your account.',
        'auth.register.highlight.3.title': 'Apply first if you need access',
        'auth.register.highlight.3.description': 'If you do not have a code yet, submit your information first.',
        'membership.center.title': 'Membership Center',
        'membership.center.currentLevel': 'Current Level',
        'membership.center.expireTime': 'Expires At',
        'membership.center.noActive': 'No active subscription',
        'membership.center.dcaPlanLimit': 'DCA Assistant plan limit',
        'membership.center.renewGuide': 'For renewal or upgrade, please contact operations (manual onboarding in phase one)',
        'membership.center.contact': 'Contact Operations',
        'membership.center.history': 'Subscription History',
        'membership.center.history.empty': 'No subscription records',
        'membership.center.compare': 'Levels & Features',
        'membership.center.amount': 'Amount (USDT)',
        'membership.center.startTime': 'Start Time',
        'membership.center.openMethod': 'Method',
        'membership.center.remark': 'Remark',
        'membership.center.level': 'Level',
        'membership.center.period': 'Period',
        'membership.level.0': 'Free',
        'membership.level.1': 'Starter',
        'membership.level.2': 'Pro',
        'membership.level.3': 'Expert',
        'membership.period.MONTHLY': 'Monthly',
        'membership.period.YEARLY': 'Yearly',
        'membership.period.TRIAL': '14-day Trial',
        'membership.openMethod.MANUAL': 'Manual',
        'membership.openMethod.TRIAL': 'Signup Trial',
        'membership.pricing.monthly': 'Monthly price',
        'membership.pricing.yearlyMonthly': 'Yearly (per month)',
        'membership.feature.reports': 'Reports subscription & viewing',
        'membership.feature.dca': 'DCA Assistant',
        'membership.feature.hedge': 'Hedging',
        'membership.feature.pattern': 'Pattern quick trading',
        'membership.feature.autoTrading': 'Auto trading',
        'membership.upgrade.title': 'Upgrade Membership',
        'membership.upgrade.need': 'This feature requires {level} or above',
        'membership.upgrade.desc': 'Upgrade to unlock the features below. Contact operations to subscribe.',
        'membership.upgrade.back': 'Back to Home',
        'membership.load.error': 'Failed to load membership info',
        'dca.page.title': 'DCA Assistant',
        'dca.common.cancel': 'Cancel',
        'dca.common.ok': 'OK',
        'dca.page.desc': 'Rule-based trading: auto market-buy spot when conditions are met',
        'dca.page.create': 'Create Plan',
        'dca.page.settings': 'DCA Settings',
        'dca.page.empty': 'No DCA plans yet. Click "Create Plan" to start.',
        'dca.page.loadError': 'Failed to load plans',
        'dca.page.configLoadError': 'Failed to load DCA settings',
        'dca.page.createNeedSymbols': 'No selectable symbols. Configure allowed symbols in "DCA Settings" first.',
        'dca.page.myPlans': 'My Plans',
        'dca.page.tabCalculator': 'Calculator',
        'dca.page.tabRunning': 'Running Plans',
        'dca.page.noRunningPlans': 'No running plans',
        'dca.calc.stats': 'Stats',
        'dca.calc.chart': 'Chart',
        'dca.calc.reset': 'Reset',
        'dca.calc.amount': 'Amount',
        'dca.calc.frequency': 'Frequency',
        'dca.calc.conditions': 'Conditions',
        'dca.calc.conditionSummary': '{op} · {n} rules',
        'dca.calc.currentValue': 'Current value',
        'dca.calc.invested': 'Invested',
        'dca.calc.calculate': 'Calculate',
        'dca.calc.calculating': 'Calculating…',
        'dca.calc.noResult': 'Configure the settings and press "Calculate" to preview the backtest',
        'dca.calc.amountRequired': 'Enter a buy amount greater than 0',
        'dca.calc.amountSaveFail': 'Failed to save buy amount',
        'dca.calc.rangeInvalid': 'Start time must be earlier than end time',
        'dca.calc.rangeFuture': 'End time cannot be later than now',
        'dca.calc.rangeMaxDays': '{tf} backtest range is limited to {days} days',
        'dca.calc.chartLoading': 'Loading candles…',
        'dca.calc.chartEmpty': 'No candle data',
        'dca.calc.createFromResult': 'Create plan with this setup',
        'dca.calc.buyPoint': 'Buy point',
        'dca.calc.maxBuyCount': 'Max triggers',
        'dca.calc.start': 'Start',
        'dca.calc.end': 'End',
        'dca.plan.status.ACTIVE': 'Active',
        'dca.plan.status.PAUSED': 'Paused',
        'dca.plan.status.STOPPED': 'Stopped',
        'dca.plan.status.COMPLETED': 'Completed',
        'dca.plan.lifecycle.ONCE': 'Once',
        'dca.plan.lifecycle.LOOP': 'Loop',
        'dca.plan.signal': 'Signal',
        'dca.plan.signal.0': 'Not triggered',
        'dca.plan.signal.1': 'Triggered',
        'dca.plan.blockTag': 'Blocked',
        'dca.plan.block.NO_API_ACCOUNT': 'No usable API connection',
        'dca.plan.bought': '{bought}/{max} buys',
        'dca.plan.buyProgress': 'Buys / cap',
        'dca.plan.lastChecked': 'Last check',
        'dca.plan.never': 'Never',
        'dca.plan.detail': 'Detail',
        'dca.plan.edit': 'Edit',
        'dca.plan.pause': 'Pause',
        'dca.plan.resume': 'Resume',
        'dca.plan.stop': 'Stop',
        'dca.plan.delete': 'Delete',
        'dca.plan.pauseConfirm': 'Pause this plan? Monitoring will stop.',
        'dca.plan.stopConfirm': 'Stopping is final and cannot be undone. Stop this plan?',
        'dca.plan.deleteConfirm': 'Delete this plan? (Execution history is kept)',
        'dca.plan.opOk': 'Success',
        'dca.plan.opFail': 'Operation failed',
        'dca.form.title.create': 'Create DCA Plan',
        'dca.form.title.edit': 'Edit DCA Plan',
        'dca.form.planName': 'Plan name',
        'dca.form.planNamePlaceholder': 'e.g. BTC DCA plan',
        'dca.form.planNameRequired': 'Please enter a plan name',
        'dca.form.planNameMax': 'Plan name must be at most 64 characters',
        'dca.form.symbol': 'Symbol',
        'dca.form.symbolRequired': 'Please select a symbol',
        'dca.form.symbolEmpty': 'No selectable symbols. Configure them in "DCA Settings" first.',
        'dca.form.lifecycle': 'Trigger mode',
        'dca.form.lifecycle.onceTip': 'Plan completes after one trigger',
        'dca.form.lifecycle.loopTip': 'Keeps buying on triggers until the cap',
        'dca.form.timeframe': 'K-line timeframe',
        'dca.form.timeframeRequired': 'Please select a timeframe',
        'dca.form.monitorFrequency': 'Monitor frequency (minutes)',
        'dca.form.monitorFrequencyRequired': 'Frequency must be within 1~1440',
        'dca.form.monitorFrequencyUnit': 'min',
        'dca.form.unlimited': 'Unlimited',
        'dca.form.maxBuyCount': 'Loop buy count cap',
        'dca.form.maxBuyCountRequired': 'Please enter the buy count cap',
        'dca.form.dailyMaxTriggers': 'Daily trigger cap',
        'dca.form.dailyMaxTriggersPlaceholder': 'Leave empty for unlimited',
        'dca.form.dailyMaxTriggersPlaceholderEdit': 'Empty keeps the current value',
        'dca.form.conditions': 'Trigger conditions',
        'dca.form.conditionsTip': 'Closed candles are monitored; the combined conditions trigger an auto buy (1~5)',
        'dca.form.op': 'Combination',
        'dca.form.op.AND': 'All met (AND)',
        'dca.form.op.OR': 'Any met (OR)',
        'dca.form.add': 'Add condition',
        'dca.form.maxReached': 'At most 5 conditions',
        'dca.form.conditionEmpty': 'Add at least 1 condition',
        'dca.form.condParams': 'Parameters',
        'dca.form.remove': 'Delete',
        'dca.form.paramInvalid': 'Condition parameters are incomplete or invalid',
        'dca.form.preview': 'Preview',
        'dca.form.previewEmpty': '--',
        'dca.form.risk': 'Risk acknowledgement',
        'dca.form.riskText': 'I understand: the system will auto market-buy spot when conditions are met. Losses are possible and returns are not guaranteed.',
        'dca.form.riskRequired': 'Risk acknowledgement is required to create a plan',
        'dca.form.submit': 'Create Plan',
        'dca.form.save': 'Save Changes',
        'dca.form.saveOk': 'Saved',
        'dca.form.saveFail': 'Save failed',
        'dca.cond.EMA_CROSS': 'EMA fast/slow relation',
        'dca.cond.PRICE_CROSS_EMA': 'Price vs EMA relation',
        'dca.cond.SMA_CROSS': 'SMA fast/slow relation',
        'dca.cond.RSI': 'RSI vs level relation',
        'dca.cond.MACD_CROSS': 'MACD DIF/DEA relation',
        'dca.cond.PRICE_BELOW': 'Price below value',
        'dca.cond.DRAWDOWN': 'Range drawdown',
        'dca.cond.LOW_TOUCH': 'Touches last N lows',
        'dca.cond.fast': 'Fast period',
        'dca.cond.slow': 'Slow period',
        'dca.cond.period': 'Period',
        'dca.cond.dir': 'Direction',
        'dca.cond.mode': 'Comparison',
        'dca.cond.mode.CROSS_UP': 'above',
        'dca.cond.mode.CROSS_DOWN': 'below',
        'dca.cond.level': 'Level',
        'dca.cond.value': 'Price',
        'dca.cond.windowMin': 'Window (min)',
        'dca.cond.pct': 'Drawdown (%)',
        'dca.cond.periods': 'Candles',
        'dca.cond.range': 'Must be within [{min}, {max}]',
        'dca.cond.rsilevel': 'Must be within (0, 100)',
        'dca.cond.pctRange': 'Must be within (0, 100)',
        'dca.cond.windowMinMin': 'Must be ≥ 60',
        'dca.cond.valuePositive': 'Must be greater than 0',
        'dca.preview.and': 'All of the following:',
        'dca.preview.or': 'Any of the following:',
        'dca.preview.EMA_CROSS': 'EMA fast {fast} {dir} slow {slow}',
        'dca.preview.PRICE_CROSS_EMA': 'Price {dir} EMA{period}',
        'dca.preview.SMA_CROSS': 'SMA fast {fast} {dir} slow {slow}',
        'dca.preview.RSI': 'RSI{period} {mode} {level}',
        'dca.preview.MACD_CROSS': 'MACD DIF {dir} DEA (12/26/9)',
        'dca.preview.PRICE_BELOW': 'Close below {value}',
        'dca.preview.DRAWDOWN': 'Drawdown over last {windowMin} min exceeds {pct}%',
        'dca.preview.LOW_TOUCH': 'Touches the low of last {periods} candles',
        'dca.dir.golden': 'above',
        'dca.dir.death': 'below',
        'dca.dir.crossUp': 'above',
        'dca.dir.crossDown': 'below',
        'dca.detail.title': 'Plan Detail',
        'dca.detail.basic': 'Basic Info',
        'dca.detail.conditions': 'Trigger Conditions',
        'dca.detail.executions': 'Executions',
        'dca.detail.execEmpty': 'No executions yet',
        'dca.detail.time': 'Trigger time',
        'dca.detail.status': 'Status',
        'dca.detail.amount': 'Amount (U)',
        'dca.detail.fill': 'Fill',
        'dca.detail.avgPx': 'Avg price',
        'dca.detail.reason': 'Reason',
        'dca.detail.snapshot': 'Condition snapshot',
        'dca.detail.dryRun': 'Simulated',
        'dca.detail.exec.EXECUTING': 'Executing',
        'dca.detail.exec.SUCCESS': 'Success',
        'dca.detail.exec.FAILED': 'Failed',
        'dca.detail.riskConfirmedAt': 'Risk confirmed at',
        'dca.detail.blockReason': 'Block reason',
        'dca.detail.createdAt': 'Created at',
        'dca.detail.updatedAt': 'Updated at',
        'dca.detail.loadExecError': 'Failed to load executions',
        'dca.cost.title': 'Cost Tracking',
        'dca.cost.quantity': 'Total quantity',
        'dca.cost.amount': 'Total amount (U)',
        'dca.cost.avgCost': 'Avg cost',
        'dca.cost.currentPrice': 'Current price',
        'dca.cost.pnl': 'Unrealized PnL (U)',
        'dca.cost.loadError': 'Failed to load cost data',
        'dca.settings.title': 'DCA Settings',
        'dca.settings.amount': 'Amount per buy (USDT)',
        'dca.settings.amountRequired': 'Amount must be greater than 0',
        'dca.settings.notify': 'Notification policy',
        'dca.settings.notify.EVERY': 'Notify on every trigger',
        'dca.settings.notify.DAILY_SUMMARY': 'Daily summary for success, immediate for failure',
        'dca.settings.notify.OFF': 'Off',
        'dca.settings.dailyLimit': 'Daily total buy cap (USDT)',
        'dca.settings.dailyLimitPlaceholder': 'Leave empty to use platform limit',
        'dca.settings.platformLimitTip': 'Platform hard limits: {amount} U per buy / {daily} U per day / {count} buys per plan / {triggers} triggers per day. Leaving blank or exceeding falls back to the platform limit',
        'dca.settings.visible': 'Visible symbols',
        'dca.settings.visibleTip': 'Must be a subset of the system whitelist; narrowing auto-pauses affected plans',
        'dca.settings.allowed': 'Allowed symbols (for plans)',
        'dca.settings.allowedTip': 'Must be a subset of visible symbols; empty = cannot create plans',
        'dca.settings.noGlobal': 'No symbols configured by the system yet',
        'dca.settings.save': 'Save Settings',
        'dca.settings.saveOk': 'Settings saved',
        'dca.settings.saveFail': 'Failed to save settings',
        'dca.settings.loading': 'Loading configuration…',
        'dca.settings.configNotLoaded': 'Configuration has not finished loading; cannot save',
        'dca.resume.title': 'Resume Plan',
        'dca.resume.riskText': 'This plan has no risk acknowledgement yet. Resuming means the system will auto market-buy spot on conditions. Please confirm you understand the auto-trading risk.',
        'dca.resume.confirm': 'Confirm Resume',
        'dca.plan.backtest': 'Backtest',
        'dca.form.backtest': 'Backtest',
        'dca.backtest.title': 'Backtest',
        'dca.backtest.rangeDays': 'Backtest range',
        'dca.backtest.run': 'Run backtest',
        'dca.backtest.running': 'Backtesting…',
        'dca.backtest.amountTip': 'Each trigger simulates a buy of {amount} USDT from your DCA settings',
        'dca.backtest.range.7': 'Last 7 days',
        'dca.backtest.range.30': 'Last 30 days',
        'dca.backtest.range.90': 'Last 90 days',
        'dca.backtest.rangeInfo': 'Backtest window',
        'dca.backtest.klineCount': 'K-lines',
        'dca.backtest.stats.triggers': 'Triggers',
        'dca.backtest.stats.quantity': 'Total quantity',
        'dca.backtest.stats.amount': 'Total invested',
        'dca.backtest.stats.avgCost': 'Avg cost',
        'dca.backtest.stats.latestPrice': 'Latest price',
        'dca.backtest.stats.pnl': 'Unrealized PnL',
        'dca.backtest.stats.maxDrawdown': 'Max drawdown',
        'dca.backtest.list': 'Trigger list',
        'dca.backtest.list.time': 'Time',
        'dca.backtest.list.price': 'Price',
        'dca.backtest.list.amount': 'Amount',
        'dca.backtest.list.quantity': 'Quantity',
        'dca.backtest.empty': 'No triggers in this range',
        'dca.backtest.error': 'Backtest failed'
    },
    'ko-KR': {
        'app.lang.zh-CN': '간체',
        'app.lang.zh-TW': '번체',
        'app.lang.en-US': 'EN',
        'app.lang.ko-KR': '한국어',
        'app.lang.ja-JP': '日本語',
        'app.lang.fr-FR': 'Français',
        'app.lang.es-ES': '스페인어',
        'site.brand.subtitle': '트레이더를 위한 AI 자산 관리',
        'site.header.drawerTitle': '사이트 내비게이션',
        'site.header.resource': '리소스',
        'site.footer.navigation': '사이트 맵',
        'site.footer.risk': '위험 고지',
        'site.footer.riskText': '거래 보조용으로만 제공됩니다. 투자 조언이 아니며 수익을 보장하지 않습니다.',
        'site.footer.bottomLeft': '© 2026 D-Sense AI Quant',
        'site.footer.bottomRight': '초대 코드 등록, 단계적 오픈',
        'site.announcement.label': '최신 소식',
        'site.announcement.action': '보기',
        'site.announcement.fallback': '현재 공식 사이트는 AI 퀀트 제품 내러티브로 전환되었으며, 체험 신청은 계속 초대 코드 제도를 사용합니다.',
        'site.splitShowcase.panel': '쇼케이스',
        'site.splitShowcase.structured': '구조화된 표현',
        'site.pocTradingView.title': '트레이딩 워크스테이션',
        'site.pocTradingView.subtitle': '실시간 데이터 표시, 거래 비활성화',
        'site.pocTradingView.notice': '실시간 트레이딩 데이터를 표시합니다. 주문, 청산, 주문 취소 등은 비활성화되어 있습니다. 전체 기능은 로그인 후 트레이딩 페이지에서 이용하세요.',
        'site.pocTradingView.noConnection': '글로벌 디스플레이 연결이 구성되지 않았습니다',
        'site.pocTradingView.loadError': '트레이딩 데이터를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.',
        'site.pocTradingView.errorTitle': '로딩 실패',
        'site.pocTradingView.retry': '재시도',
        'site.pocBotView.title': 'AI 자동 트레이딩 워크스테이션',
        'site.pocBotView.subtitle': '실시간 인터랙티브 데모',
        'site.pocBotView.notice': 'AI 자동 트레이딩 전체 프로세스를 보여줍니다. API Key 선택, 환경 설정, Prompt 생성, 결정 내역 확인.',
        'site.risk.ruleLabel': '리스크 관리 규칙',
        'site.contactPanel.eyebrow': '초대 코드 받기',
        'site.contactPanel.title': '초대 코드가 없으면 먼저 정보를 제출하세요',
        'site.contactPanel.description': '초대 코드가 있으면 바로 등록하고, 없으면 먼저 정보를 제출할 수 있습니다.',
        'site.contactPanel.email': '이메일',
        'site.contactPanel.startPath': '시작 방법',
        'site.contactPanel.startPathValue': '정보 제출 → 초대 코드 받기 → 계정 등록 → 시스템 로그인',
        'site.contactPanel.audience': '대상',
        'site.contactPanel.audienceValue': '차트 모니터링 시간을 줄이고 판단 효율성을 높이려는 개인 트레이더',
        'site.contactPanel.name': '이름',
        'site.contactPanel.namePlaceholder': '이름을 입력하세요',
        'site.contactPanel.contact': '연락처',
        'site.contactPanel.contactPlaceholder': '휴대폰 번호 또는 이메일을 입력하세요',
        'site.contactPanel.experience': '거래 경험',
        'site.contactPanel.experiencePlaceholder': '거래 경험과 사용 시나리오를 간단히 설명해주세요',
        'site.contactPanel.focus': '관심 분야',
        'site.contactPanel.focusPlaceholder': '관심 분야를 선택하세요',
        'site.contactPanel.focus.ai': 'AI 분석 능력',
        'site.contactPanel.focus.trade': '자동 거래 실행',
        'site.contactPanel.focus.risk': '리스크 관리 및 자산 보기',
        'site.contactPanel.note': '추가 설명',
        'site.contactPanel.notePlaceholder': '가장 관심 있는 기능과 현재 사용 습관을 알려주세요',
        'site.contactPanel.invite': '초대 코드 받기',
        'site.contactPanel.register': '지금 등록',
        'site.contactPanel.login': '로그인하기',
        'site.contactModal.title': '문의하기',
        'site.contactModal.label.name': '이름',
        'site.contactModal.label.email': '연락 이메일',
        'site.contactModal.label.phone': '연락처',
        'site.contactModal.label.subject': '주제',
        'site.contactModal.label.content': '내용',
        'site.contactModal.placeholder.name': '이름을 입력하세요',
        'site.contactModal.placeholder.email': '연락 이메일',
        'site.contactModal.placeholder.phone': '연락처 (선택)',
        'site.contactModal.placeholder.subject': '주제를 선택하세요',
        'site.contactModal.placeholder.content': '문의 내용을 입력하세요',
        'site.contactModal.rule.name': '이름을 입력하세요',
        'site.contactModal.rule.email': '연락 이메일을 입력하세요',
        'site.contactModal.rule.emailType': '유효한 이메일을 입력하세요',
        'site.contactModal.rule.subject': '주제를 선택하세요',
        'site.contactModal.rule.content': '문의 내용을 입력하세요',
        'site.contactModal.subject.product': '제품 문의',
        'site.contactModal.subject.cooperation': '협력 문의',
        'site.contactModal.subject.tech': '기술 문의',
        'site.contactModal.subject.feedback': '의견 제안',
        'site.contactModal.subject.other': '기타',
        'site.contactModal.okText': '제출',
        'site.contactModal.cancelText': '취소',
        'site.contactModal.success': '제출 성공, 곧 연락드리겠습니다',
        'site.contactModal.fail': '제출 실패, 나중에 다시 시도하세요',
        'site.waitlistModal.title': '초대 코드 받기',
        'site.waitlistModal.placeholder.name': '이름',
        'site.waitlistModal.placeholder.email': '연락 이메일',
        'site.waitlistModal.placeholder.direction': '관심 분야',
        'site.waitlistModal.rule.name': '이름을 입력하세요',
        'site.waitlistModal.rule.email': '유효한 이메일을 입력하세요',
        'site.waitlistModal.rule.emailType': '유효한 이메일을 입력하세요',
        'site.waitlistModal.rule.direction': '관심 분야를 선택하세요',
        'site.waitlistModal.okText': '신청 제출',
        'site.waitlistModal.cancelText': '취소',
        'site.waitlistModal.success': '신청이 접수되었습니다. 곧 연락드리겠습니다',
        'site.waitlistModal.fail': '제출 실패, 나중에 다시 시도하세요',
        'site.waitlistModal.direction.assist': 'AI 보조 트레이딩',
        'site.waitlistModal.direction.auto': '자동 거래',
        'site.waitlistModal.direction.asset': '자산 관리',
        'site.waitlistModal.direction.risk': '리스크 관리',
        'site.waitlistModal.direction.other': '기타',
        'auth.login.actionHome': '공식 사이트로 돌아가기',
        'auth.login.eyebrow': '트레이딩 워크스테이션',
        'auth.login.title': 'D-Sense 계정에 로그인',
        'auth.login.panelTitle': '돌아오신 것을 환영합니다',
        'auth.login.description': '로그인 후 전략 성과, 자산 개요 및 실행 기록을 확인하세요.',
        'auth.login.footnote': '이미 계정이 있으신가요? 지금 로그인하세요. 아직 초대 코드가 없으신가요?',
        'auth.login.cardTitle': '계정 로그인',
        'auth.login.cardDescription': '로그인 후 시스템을 계속 사용합니다.',
        'auth.login.usernameRequired': '사용자 이름을 입력하세요',
        'auth.login.passwordRequired': '비밀번호를 입력하세요',
        'auth.login.passwordMin': '비밀번호는 최소 6자리 이상',
        'auth.login.usernamePlaceholder': '사용자 이름',
        'auth.login.passwordPlaceholder': '비밀번호',
        'auth.login.submit': '로그인',
        'auth.login.noAccount': '계정이 없으신가요?',
        'auth.login.register': '초대 코드 등록',
        'auth.login.getInvite': '초대 코드 받기',
        'auth.login.alreadyLoggedIn': '로그인 상태 감지됨',
        'auth.login.enterSystem': '시스템 입장',
        'auth.login.highlight.1.title': '차세대 자산 관리 서비스',
        'auth.login.highlight.1.description': '로그인 후 AI 자산 관리 서비스를 시작하세요',
        'auth.login.highlight.2.title': '소규모 사용자 테스트를 진행 중입니다',
        'auth.login.highlight.2.description': '로그인하고 거래 여정을 시작하세요',
        'auth.login.highlight.3.title': '위험 경고',
        'auth.login.highlight.3.description': 'D-sense는 AI 자산 관리자이며 어떠한 수익도 보장하지 않습니다.',
        'auth.register.actionPoc': 'POC 보기',
        'auth.register.eyebrow': '시작하기',
        'auth.register.title': 'D-Sense 계정 등록',
        'auth.register.description': '초대 코드와 계정 정보를 입력하면 시작할 수 있습니다.',
        'auth.register.footnote': '초대 코드가 있으면 바로 등록, 없으면 먼저 받으세요.',
        'auth.register.cardTitle': '초대 코드 등록',
        'auth.register.cardDescription': '초대 코드를 입력한 후 등록할 수 있습니다.',
        'auth.register.step.verify': '초대 코드 확인',
        'auth.register.step.verifyDescription': '초대 코드를 입력하세요',
        'auth.register.step.create': '정보 입력',
        'auth.register.step.createDescription': '계정을 생성하세요',
        'auth.register.enterCode': '초대 코드를 입력하세요',
        'auth.register.codeLabel': '초대 코드',
        'auth.register.codePlaceholder': '초대 코드를 입력하세요',
        'auth.register.codeSubmit': '초대 코드 확인',
        'auth.register.codeEmpty': '초대 코드를 입력하세요',
        'auth.register.codeFailed': '확인에 실패했습니다. 나중에 다시 시도하세요.',
        'auth.register.usernameRequired': '사용자 이름을 입력하세요',
        'auth.register.usernameMin': '사용자 이름은 최소 3자리 이상',
        'auth.register.usernameMax': '사용자 이름은 최대 50자리',
        'auth.register.usernamePlaceholder': '사용자 이름 (3-50자)',
        'auth.register.emailRequired': '이메일을 입력하세요',
        'auth.register.emailInvalid': '유효한 이메일 주소를 입력하세요',
        'auth.register.emailPlaceholder': '이메일',
        'auth.register.passwordRequired': '비밀번호를 입력하세요',
        'auth.register.passwordMin': '비밀번호는 최소 6자리 이상',
        'auth.register.passwordPlaceholder': '비밀번호 (최소 6자)',
        'auth.register.confirmRequired': '비밀번호를 확인하세요',
        'auth.register.confirmPlaceholder': '비밀번호 확인',
        'auth.register.confirmMismatch': '두 번 입력한 비밀번호가 일치하지 않습니다',
        'auth.register.previous': '이전 단계',
        'auth.register.submit': '등록',
        'auth.register.existing': '이미 계정이 있으신가요?',
        'auth.register.login': '로그인',
        'auth.register.getInvite': '초대 코드 받기',
        'auth.register.currentCode': '초대 코드',
        'auth.register.highlight.1.title': '초대 코드로 바로 시작',
        'auth.register.highlight.1.description': '초대 코드를 입력하면 바로 시작할 수 있습니다.',
        'auth.register.highlight.2.title': '더 간편한 등록 절차',
        'auth.register.highlight.2.description': '먼저 코드 확인 후 등록합니다.',
        'auth.register.highlight.3.title': '초대 코드가 없으면 먼저 받기',
        'auth.register.highlight.3.description': '초대 코드가 없으면 먼저 정보를 제출할 수 있습니다.'
    },
    'ja-JP': {
        'app.lang.zh-CN': '簡体',
        'app.lang.zh-TW': '繁体',
        'app.lang.en-US': 'EN',
        'app.lang.ko-KR': '한국어',
        'app.lang.ja-JP': '日本語',
        'app.lang.fr-FR': 'Français',
        'app.lang.es-ES': 'スペイン語',
        'site.brand.subtitle': 'トレーダーのためのAI資産管理',
        'site.header.drawerTitle': 'サイトナビゲーション',
        'site.header.resource': 'リソース',
        'site.footer.navigation': 'サイトマップ',
        'site.footer.risk': 'リスク声明',
        'site.footer.riskText': '取引補助用です。投資アドバイスではなく、収益を約束するものではありません。',
        'site.footer.bottomLeft': '© 2026 D-Sense AI Quant',
        'site.footer.bottomRight': '招待コード登録、段階的に開放',
        'site.announcement.label': '最新情報',
        'site.announcement.action': '見る',
        'site.announcement.fallback': '現在の公式サイトはAIクオンツ製品のストーリーに切り替わりました。体験申し込みは引き続き招待コード制を採用しています。',
        'site.splitShowcase.panel': 'ショーケース',
        'site.splitShowcase.structured': '構造化表現',
        'site.pocTradingView.title': 'トレーディングワークステーション',
        'site.pocTradingView.subtitle': 'リアルタイムデータ表示、操作は無効',
        'site.pocTradingView.notice': 'リアルタイム取引データの表示。注文、決済、取消などの操作は無効です。完全な機能はログイン後、取引ページでご利用いただけます。',
        'site.pocTradingView.noConnection': 'グローバル表示接続が設定されていません',
        'site.pocTradingView.loadError': '取引データの読み込みに失敗しました。後でもう一度お試しください。',
        'site.pocTradingView.errorTitle': '読み込み失敗',
        'site.pocTradingView.retry': '再試行',
        'site.pocBotView.title': 'AI自動取引ワークステーション',
        'site.pocBotView.subtitle': 'リアルタイムデモ',
        'site.pocBotView.notice': 'AI自動取引の全プロセスを表示します。API Keyの選択、設定、プロンプト生成、判断履歴の確認。',
        'site.risk.ruleLabel': 'リスク管理ルール',
        'site.contactPanel.eyebrow': '招待コードを取得',
        'site.contactPanel.title': '招待コードがない場合、情報を送信してください',
        'site.contactPanel.description': '招待コードがあれば直接登録、なければ情報を送信していただけます。',
        'site.contactPanel.email': 'メール',
        'site.contactPanel.startPath': '開始方法',
        'site.contactPanel.startPathValue': '情報送信 → 招待コード受取 → アカウント登録 → システムログイン',
        'site.contactPanel.audience': '対象',
        'site.contactPanel.audienceValue': 'チャート監視時間を減らし、判断効率を高めたい個人トレーダー向け',
        'site.contactPanel.name': '名前',
        'site.contactPanel.namePlaceholder': '名前を入力してください',
        'site.contactPanel.contact': '連絡先',
        'site.contactPanel.contactPlaceholder': '電話番号またはメールアドレスを入力してください',
        'site.contactPanel.experience': '取引経験',
        'site.contactPanel.experiencePlaceholder': '取引経験と使用シナリオを簡単に説明してください',
        'site.contactPanel.focus': '関心分野',
        'site.contactPanel.focusPlaceholder': '関心分野を選択してください',
        'site.contactPanel.focus.ai': 'AI分析能力',
        'site.contactPanel.focus.trade': '自動取引実行',
        'site.contactPanel.focus.risk': 'リスク管理と資産ビュー',
        'site.contactPanel.note': '補足説明',
        'site.contactPanel.notePlaceholder': '最も使いたい機能と現在の習慣をお知らせください',
        'site.contactPanel.invite': '招待コードを取得',
        'site.contactPanel.register': '今すぐ登録',
        'site.contactPanel.login': 'ログインへ',
        'site.contactModal.title': 'お問い合わせ',
        'site.contactModal.label.name': 'お名前',
        'site.contactModal.label.email': '連絡先メール',
        'site.contactModal.label.phone': '電話番号',
        'site.contactModal.label.subject': '件名',
        'site.contactModal.label.content': 'お問い合わせ内容',
        'site.contactModal.placeholder.name': 'お名前をご入力ください',
        'site.contactModal.placeholder.email': '連絡先メール',
        'site.contactModal.placeholder.phone': '電話番号（任意）',
        'site.contactModal.placeholder.subject': '件名を選択してください',
        'site.contactModal.placeholder.content': 'お問い合わせ内容をご入力ください',
        'site.contactModal.rule.name': 'お名前をご入力ください',
        'site.contactModal.rule.email': '連絡先メールをご入力ください',
        'site.contactModal.rule.emailType': '有効なメールアドレスをご入力ください',
        'site.contactModal.rule.subject': '件名を選択してください',
        'site.contactModal.rule.content': 'お問い合わせ内容をご入力ください',
        'site.contactModal.subject.product': '製品に関するお問い合わせ',
        'site.contactModal.subject.cooperation': '協業のご提案',
        'site.contactModal.subject.tech': '技術的な質問',
        'site.contactModal.subject.feedback': 'フィードバック',
        'site.contactModal.subject.other': 'その他',
        'site.contactModal.okText': '送信',
        'site.contactModal.cancelText': 'キャンセル',
        'site.contactModal.success': '送信しました。すぐにご連絡いたします',
        'site.contactModal.fail': '送信に失敗しました。後でもう一度お試しください',
        'site.waitlistModal.title': '招待コードを取得',
        'site.waitlistModal.placeholder.name': 'お名前',
        'site.waitlistModal.placeholder.email': '連絡先メール',
        'site.waitlistModal.placeholder.direction': '関心のある分野',
        'site.waitlistModal.rule.name': 'お名前をご入力ください',
        'site.waitlistModal.rule.email': '有効なメールアドレスをご入力ください',
        'site.waitlistModal.rule.emailType': '有効なメールアドレスをご入力ください',
        'site.waitlistModal.rule.direction': '関心のある分野を選択してください',
        'site.waitlistModal.okText': '申請を送信',
        'site.waitlistModal.cancelText': 'キャンセル',
        'site.waitlistModal.success': '申請を受け付けました。すぐにご連絡いたします',
        'site.waitlistModal.fail': '送信に失敗しました。後でもう一度お試しください',
        'site.waitlistModal.direction.assist': 'AI アシスト取引',
        'site.waitlistModal.direction.auto': '自動取引',
        'site.waitlistModal.direction.asset': '資産管理',
        'site.waitlistModal.direction.risk': 'リスク管理',
        'site.waitlistModal.direction.other': 'その他',
        'auth.login.actionHome': '公式サイトに戻る',
        'auth.login.eyebrow': 'トレーディングワークステーション',
        'auth.login.title': 'D-Senseアカウントにログイン',
        'auth.login.panelTitle': 'お帰りなさい',
        'auth.login.description': 'ログイン後、戦略パフォーマンス、資産概要、実行記録を確認できます。',
        'auth.login.footnote': 'アカウントをお持ちの方はログインしてください。招待コードがまだの方はこちらから。',
        'auth.login.cardTitle': 'アカウントログイン',
        'auth.login.cardDescription': 'ログインしてシステムを続けてご利用ください。',
        'auth.login.usernameRequired': 'ユーザー名を入力してください',
        'auth.login.passwordRequired': 'パスワードを入力してください',
        'auth.login.passwordMin': 'パスワードは6文字以上',
        'auth.login.usernamePlaceholder': 'ユーザー名',
        'auth.login.passwordPlaceholder': 'パスワード',
        'auth.login.submit': 'ログイン',
        'auth.login.noAccount': 'アカウントをお持ちでないですか？',
        'auth.login.register': '招待コード登録',
        'auth.login.getInvite': '招待コードを取得',
        'auth.login.alreadyLoggedIn': 'ログイン状態を検出しました',
        'auth.login.enterSystem': 'システムに入る',
        'auth.login.highlight.1.title': '次世代資産管理サービス',
        'auth.login.highlight.1.description': 'ログイン後、AI資産管理サービスを開始',
        'auth.login.highlight.2.title': '小規模ユーザーテストを実施中です',
        'auth.login.highlight.2.description': 'ログインしてトレードの旅を始めましょう',
        'auth.login.highlight.3.title': 'リスク警告',
        'auth.login.highlight.3.description': 'D-senseはAI資産管理サービスであり、いかなる収益も保証しません。',
        'auth.register.actionPoc': 'POCを見る',
        'auth.register.eyebrow': '始める',
        'auth.register.title': 'D-Senseアカウントを登録',
        'auth.register.description': '招待コードとアカウント情報を入力して開始できます。',
        'auth.register.footnote': '招待コードがあれば直接登録、なければ先に取得してください。',
        'auth.register.cardTitle': '招待コード登録',
        'auth.register.cardDescription': '招待コードを入力して登録できます。',
        'auth.register.step.verify': '招待コード検証',
        'auth.register.step.verifyDescription': '招待コードを入力してください',
        'auth.register.step.create': '情報入力',
        'auth.register.step.createDescription': 'アカウントを作成',
        'auth.register.enterCode': '招待コードを入力してください',
        'auth.register.codeLabel': '招待コード',
        'auth.register.codePlaceholder': '招待コードを入力',
        'auth.register.codeSubmit': '招待コードを検証',
        'auth.register.codeEmpty': '招待コードを入力してください',
        'auth.register.codeFailed': '検証に失敗しました。後でもう一度お試しください。',
        'auth.register.usernameRequired': 'ユーザー名を入力してください',
        'auth.register.usernameMin': 'ユーザー名は3文字以上',
        'auth.register.usernameMax': 'ユーザー名は最大50文字',
        'auth.register.usernamePlaceholder': 'ユーザー名（3-50文字）',
        'auth.register.emailRequired': 'メールアドレスを入力してください',
        'auth.register.emailInvalid': '有効なメールアドレスを入力してください',
        'auth.register.emailPlaceholder': 'メール',
        'auth.register.passwordRequired': 'パスワードを入力してください',
        'auth.register.passwordMin': 'パスワードは6文字以上',
        'auth.register.passwordPlaceholder': 'パスワード（6文字以上）',
        'auth.register.confirmRequired': 'パスワードを確認してください',
        'auth.register.confirmPlaceholder': 'パスワード確認',
        'auth.register.confirmMismatch': '入力したパスワードが一致しません',
        'auth.register.previous': '戻る',
        'auth.register.submit': '登録',
        'auth.register.existing': 'すでにアカウントをお持ちですか？',
        'auth.register.login': 'ログイン',
        'auth.register.getInvite': '招待コードを取得',
        'auth.register.currentCode': '招待コード',
        'auth.register.highlight.1.title': '招待コードで開始',
        'auth.register.highlight.1.description': '招待コードを入力するとすぐに開始できます。',
        'auth.register.highlight.2.title': '登録プロセスがより簡単に',
        'auth.register.highlight.2.description': 'コード検証後、登録します。',
        'auth.register.highlight.3.title': '招待コードがなければ先に取得',
        'auth.register.highlight.3.description': '招待コードがなければ先に情報を送信できます。'
    },
    'fr-FR': {
        'app.lang.zh-CN': 'SC',
        'app.lang.zh-TW': 'TC',
        'app.lang.en-US': 'EN',
        'app.lang.ko-KR': 'KO',
        'app.lang.ja-JP': 'JA',
        'app.lang.fr-FR': 'FR',
        'app.lang.es-ES': 'ES',
        'site.brand.subtitle': 'Gestionnaire d\'actifs IA pour traders',
        'site.header.drawerTitle': 'Navigation du site',
        'site.header.resource': 'Ressources',
        'site.footer.navigation': 'Plan du site',
        'site.footer.risk': 'Avis de risque',
        'site.footer.riskText': 'Fourni uniquement comme aide au trading. Cela ne constitue pas un conseil en investissement et ne garantit pas de rendement.',
        'site.footer.bottomLeft': '© 2026 D-Sense AI Quant',
        'site.footer.bottomRight': 'Accès par code d\'invitation, déploiement progressif',
        'site.announcement.label': 'Dernières nouvelles',
        'site.announcement.action': 'Voir',
        'site.announcement.fallback': 'Le site officiel présente désormais le récit du produit IA quantitatif. Les demandes d\'essai continuent d\'utiliser le système de code d\'invitation.',
        'site.splitShowcase.panel': 'Vitrine',
        'site.splitShowcase.structured': 'Expression structurée',
        'site.pocTradingView.title': 'Poste de trading',
        'site.pocTradingView.subtitle': 'Affichage des données en temps réel, opérations désactivées',
        'site.pocTradingView.notice': 'Affichage des données de trading en temps réel. Les opérations de passation d\'ordres, de clôture et d\'annulation sont désactivées. Veuillez vous connecter pour accéder à la page de trading complète.',
        'site.pocTradingView.noConnection': 'Aucune connexion d\'affichage global configurée',
        'site.pocTradingView.loadError': 'Échec du chargement des données de trading. Veuillez réessayer plus tard.',
        'site.pocTradingView.errorTitle': 'Échec du chargement',
        'site.pocTradingView.retry': 'Réessayer',
        'site.pocBotView.title': 'Poste de trading automatique IA',
        'site.pocBotView.subtitle': 'Démo interactive en temps réel',
        'site.pocBotView.notice': 'Présentation complète du processus de trading automatique IA. Sélectionnez la clé API, définissez les préférences, générez des prompts et consultez l\'historique des décisions.',
        'site.risk.ruleLabel': 'Règle de risque',
        'site.contactPanel.eyebrow': 'Obtenir un code d\'invitation',
        'site.contactPanel.title': 'Pas de code d\'invitation ? Soumettez d\'abord vos informations',
        'site.contactPanel.description': 'Si vous avez déjà un code d\'invitation, vous pouvez vous inscrire directement. Sinon, laissez d\'abord vos informations.',
        'site.contactPanel.email': 'Email',
        'site.contactPanel.startPath': 'Comment commencer',
        'site.contactPanel.startPathValue': 'Soumettre les infos → Recevoir le code → Créer un compte → Se connecter',
        'site.contactPanel.audience': 'Public cible',
        'site.contactPanel.audienceValue': 'Traders individuels souhaitant réduire le temps d\'écran et améliorer l\'efficacité des décisions',
        'site.contactPanel.name': 'Nom',
        'site.contactPanel.namePlaceholder': 'Entrez votre nom',
        'site.contactPanel.contact': 'Contact',
        'site.contactPanel.contactPlaceholder': 'Entrez votre numéro de téléphone ou email',
        'site.contactPanel.experience': 'Expérience de trading',
        'site.contactPanel.experiencePlaceholder': 'Décrivez brièvement votre expérience de trading et votre cas d\'utilisation',
        'site.contactPanel.focus': 'Domaine d\'intérêt',
        'site.contactPanel.focusPlaceholder': 'Sélectionnez un domaine d\'intérêt',
        'site.contactPanel.focus.ai': 'Analyse IA',
        'site.contactPanel.focus.trade': 'Exécution automatisée',
        'site.contactPanel.focus.risk': 'Contrôle des risques et vue des actifs',
        'site.contactPanel.note': 'Notes complémentaires',
        'site.contactPanel.notePlaceholder': 'Dites-nous les fonctionnalités qui vous intéressent le plus et votre flux de travail actuel',
        'site.contactPanel.invite': 'Obtenir un code d\'invitation',
        'site.contactPanel.register': 'S\'inscrire maintenant',
        'site.contactPanel.login': 'Aller à la connexion',
        'site.contactModal.title': 'Nous contacter',
        'site.contactModal.label.name': 'Nom',
        'site.contactModal.label.email': 'Email de contact',
        'site.contactModal.label.phone': 'Téléphone',
        'site.contactModal.label.subject': 'Sujet',
        'site.contactModal.label.content': 'Message',
        'site.contactModal.placeholder.name': 'Votre nom',
        'site.contactModal.placeholder.email': 'Email de contact',
        'site.contactModal.placeholder.phone': 'Téléphone (facultatif)',
        'site.contactModal.placeholder.subject': 'Veuillez sélectionner un sujet',
        'site.contactModal.placeholder.content': 'Veuillez saisir votre message',
        'site.contactModal.rule.name': 'Veuillez saisir votre nom',
        'site.contactModal.rule.email': 'Veuillez saisir votre email',
        'site.contactModal.rule.emailType': 'Veuillez saisir une adresse email valide',
        'site.contactModal.rule.subject': 'Veuillez sélectionner un sujet',
        'site.contactModal.rule.content': 'Veuillez saisir votre message',
        'site.contactModal.subject.product': 'Demande produit',
        'site.contactModal.subject.cooperation': 'Partenariat',
        'site.contactModal.subject.tech': 'Problème technique',
        'site.contactModal.subject.feedback': 'Retour d\'expérience',
        'site.contactModal.subject.other': 'Autre',
        'site.contactModal.okText': 'Envoyer',
        'site.contactModal.cancelText': 'Annuler',
        'site.contactModal.success': 'Envoyé avec succès, nous vous contacterons bientôt',
        'site.contactModal.fail': 'Échec de l\'envoi, veuillez réessayer plus tard',
        'site.waitlistModal.title': 'Obtenir un code d\'invitation',
        'site.waitlistModal.placeholder.name': 'Votre nom',
        'site.waitlistModal.placeholder.email': 'Email de contact',
        'site.waitlistModal.placeholder.direction': 'Domaine d\'intérêt',
        'site.waitlistModal.rule.name': 'Veuillez saisir votre nom',
        'site.waitlistModal.rule.email': 'Veuillez saisir une adresse email valide',
        'site.waitlistModal.rule.emailType': 'Veuillez saisir une adresse email valide',
        'site.waitlistModal.rule.direction': 'Veuillez sélectionner un domaine d\'intérêt',
        'site.waitlistModal.okText': 'Soumettre la demande',
        'site.waitlistModal.cancelText': 'Annuler',
        'site.waitlistModal.success': 'Demande envoyée, nous vous contacterons bientôt',
        'site.waitlistModal.fail': 'Échec de l\'envoi, veuillez réessayer plus tard',
        'site.waitlistModal.direction.assist': 'Trading Assisté IA',
        'site.waitlistModal.direction.auto': 'Trading Automatique',
        'site.waitlistModal.direction.asset': 'Gestion d\'Actifs',
        'site.waitlistModal.direction.risk': 'Contrôle des Risques',
        'site.waitlistModal.direction.other': 'Autre',
        'auth.login.actionHome': 'Retour au site',
        'auth.login.eyebrow': 'Poste de trading',
        'auth.login.title': 'Connectez-vous à votre compte D-Sense',
        'auth.login.panelTitle': 'Bon retour',
        'auth.login.description': 'Consultez vos performances stratégiques, l\'aperçu de vos actifs et l\'historique d\'exécution après connexion.',
        'auth.login.footnote': 'Vous avez déjà un compte ? Connectez-vous. Pas encore de code d\'invitation ?',
        'auth.login.cardTitle': 'Connexion au compte',
        'auth.login.cardDescription': 'Connectez-vous pour continuer à utiliser D-Sense.',
        'auth.login.usernameRequired': 'Veuillez entrer votre nom d\'utilisateur',
        'auth.login.passwordRequired': 'Veuillez entrer votre mot de passe',
        'auth.login.passwordMin': 'Le mot de passe doit contenir au moins 6 caractères',
        'auth.login.usernamePlaceholder': 'Nom d\'utilisateur',
        'auth.login.passwordPlaceholder': 'Mot de passe',
        'auth.login.submit': 'Se connecter',
        'auth.login.noAccount': 'Pas encore de compte ?',
        'auth.login.register': 'Inscription par invitation',
        'auth.login.getInvite': 'Obtenir un code d\'invitation',
        'auth.login.alreadyLoggedIn': 'Connecté en tant que',
        'auth.login.enterSystem': 'Entrer dans le système',
        'auth.login.highlight.1.title': 'Gestion d\'actifs nouvelle génération',
        'auth.login.highlight.1.description': 'Connectez-vous pour démarrer la gestion d\'actifs IA',
        'auth.login.highlight.2.title': 'Nous menons un test utilisateur à petite échelle',
        'auth.login.highlight.2.description': 'Connectez-vous et commencez votre parcours de trading',
        'auth.login.highlight.3.title': 'Avertissement',
        'auth.login.highlight.3.description': 'D-sense est un gestionnaire d\'actifs IA et ne garantit aucun rendement.',
        'auth.register.actionPoc': 'Voir la POC',
        'auth.register.eyebrow': 'Commencer',
        'auth.register.title': 'Créez votre compte D-Sense',
        'auth.register.description': 'Entrez votre code d\'invitation et vos informations de compte pour commencer.',
        'auth.register.footnote': 'Vous avez un code ? Inscrivez-vous. Besoin d\'un accès ? Faites une demande d\'abord.',
        'auth.register.cardTitle': 'Inscription par code d\'invitation',
        'auth.register.cardDescription': 'Entrez un code d\'invitation valide pour créer votre compte.',
        'auth.register.step.verify': 'Vérifier le code',
        'auth.register.step.verifyDescription': 'Entrez votre code d\'invitation',
        'auth.register.step.create': 'Créer le compte',
        'auth.register.step.createDescription': 'Remplissez vos informations de compte',
        'auth.register.enterCode': 'Entrez votre code d\'invitation',
        'auth.register.codeLabel': 'Code d\'invitation',
        'auth.register.codePlaceholder': 'Entrez le code d\'invitation',
        'auth.register.codeSubmit': 'Vérifier le code d\'invitation',
        'auth.register.codeEmpty': 'Veuillez entrer votre code d\'invitation',
        'auth.register.codeFailed': 'Échec de la vérification. Veuillez réessayer plus tard.',
        'auth.register.usernameRequired': 'Veuillez entrer votre nom d\'utilisateur',
        'auth.register.usernameMin': 'Le nom d\'utilisateur doit comporter au moins 3 caractères',
        'auth.register.usernameMax': 'Le nom d\'utilisateur doit comporter au maximum 50 caractères',
        'auth.register.usernamePlaceholder': 'Nom d\'utilisateur (3-50 caractères)',
        'auth.register.emailRequired': 'Veuillez entrer votre email',
        'auth.register.emailInvalid': 'Veuillez entrer une adresse email valide',
        'auth.register.emailPlaceholder': 'Email',
        'auth.register.passwordRequired': 'Veuillez entrer votre mot de passe',
        'auth.register.passwordMin': 'Le mot de passe doit contenir au moins 6 caractères',
        'auth.register.passwordPlaceholder': 'Mot de passe (au moins 6 caractères)',
        'auth.register.confirmRequired': 'Veuillez confirmer votre mot de passe',
        'auth.register.confirmPlaceholder': 'Confirmer le mot de passe',
        'auth.register.confirmMismatch': 'Les deux mots de passe ne correspondent pas',
        'auth.register.previous': 'Précédent',
        'auth.register.submit': 'S\'inscrire',
        'auth.register.existing': 'Vous avez déjà un compte ?',
        'auth.register.login': 'Se connecter',
        'auth.register.getInvite': 'Obtenir un code d\'invitation',
        'auth.register.currentCode': 'Code d\'invitation',
        'auth.register.highlight.1.title': 'Commencez avec un code valide',
        'auth.register.highlight.1.description': 'Entrez votre code d\'invitation pour commencer l\'inscription.',
        'auth.register.highlight.2.title': 'Un parcours d\'inscription simplifié',
        'auth.register.highlight.2.description': 'Vérifiez d\'abord, puis créez votre compte.',
        'auth.register.highlight.3.title': 'Faites d\'abord une demande si besoin',
        'auth.register.highlight.3.description': 'Si vous n\'avez pas encore de code, soumettez d\'abord vos informations.'
    },
    'es-ES': {
        'app.lang.zh-CN': 'SC',
        'app.lang.zh-TW': 'TC',
        'app.lang.en-US': 'EN',
        'app.lang.ko-KR': 'KO',
        'app.lang.ja-JP': 'JA',
        'app.lang.fr-FR': 'FR',
        'app.lang.es-ES': 'Español',
        'site.brand.subtitle': 'Gestor de Activos IA para Traders',
        'site.header.drawerTitle': 'Navegación del Sitio',
        'site.header.resource': 'Recursos',
        'site.footer.navigation': 'Mapa del Sitio',
        'site.footer.risk': 'Aviso de Riesgo',
        'site.footer.riskText': 'Solo como ayuda para el trading. No constituye asesoramiento de inversión ni promete rendimientos.',
        'site.footer.bottomLeft': '© 2026 D-Sense AI Quant',
        'site.footer.bottomRight': 'Acceso mediante código de invitación, implementación gradual',
        'site.announcement.label': 'Últimas noticias',
        'site.announcement.action': 'Ver',
        'site.announcement.fallback': 'El sitio web ahora se centra en la narrativa del producto cuantitativo de IA. Las solicitudes de prueba continúan utilizando el sistema de código de invitación.',
        'site.splitShowcase.panel': 'Panel de Demostración',
        'site.splitShowcase.structured': 'Expresión Estructurada',
        'site.pocTradingView.title': 'Estación de Trading',
        'site.pocTradingView.subtitle': 'Visualización de datos en tiempo real, operaciones desactivadas',
        'site.pocTradingView.notice': 'Muestra datos de trading en tiempo real. Las operaciones de colocación de órdenes, cierre y cancelación están desactivadas. Inicie sesión para acceder a la funcionalidad completa.',
        'site.pocTradingView.noConnection': 'No hay conexión de visualización global configurada',
        'site.pocTradingView.loadError': 'Error al cargar datos de trading. Inténtelo de nuevo más tarde.',
        'site.pocTradingView.errorTitle': 'Error de Carga',
        'site.pocTradingView.retry': 'Reintentar',
        'site.pocBotView.title': 'Estación de Trading Automático IA',
        'site.pocBotView.subtitle': 'Demostración interactiva en tiempo real',
        'site.pocBotView.notice': 'Muestra el flujo completo de trading automático con IA. Seleccione API Key, configure preferencias, genere prompts y consulte el historial de decisiones.',
        'site.risk.ruleLabel': 'Reglas de Riesgo',
        'site.contactPanel.eyebrow': 'Obtener Código de Invitación',
        'site.contactPanel.title': '¿Sin código? Comparta su información primero',
        'site.contactPanel.description': 'Si ya tiene un código de invitación, regístrese ahora. De lo contrario, deje su información primero.',
        'site.contactPanel.email': 'Correo electrónico',
        'site.contactPanel.startPath': 'Cómo Empezar',
        'site.contactPanel.startPathValue': 'Enviar info → Recibir código → Crear cuenta → Iniciar sesión',
        'site.contactPanel.audience': 'Público Objetivo',
        'site.contactPanel.audienceValue': 'Traders individuales que desean reducir el tiempo frente a la pantalla y mejorar la eficiencia de las decisiones',
        'site.contactPanel.name': 'Nombre',
        'site.contactPanel.namePlaceholder': 'Ingrese su nombre',
        'site.contactPanel.contact': 'Contacto',
        'site.contactPanel.contactPlaceholder': 'Ingrese su teléfono o correo electrónico',
        'site.contactPanel.experience': 'Experiencia en Trading',
        'site.contactPanel.experiencePlaceholder': 'Describa brevemente su experiencia en trading y caso de uso',
        'site.contactPanel.focus': 'Área de Interés',
        'site.contactPanel.focusPlaceholder': 'Seleccione un área de interés',
        'site.contactPanel.focus.ai': 'Capacidad de análisis IA',
        'site.contactPanel.focus.trade': 'Ejecución automatizada de trading',
        'site.contactPanel.focus.risk': 'Control de riesgos y vista de activos',
        'site.contactPanel.note': 'Notas Adicionales',
        'site.contactPanel.notePlaceholder': 'Cuéntenos las funciones que más le interesan y su flujo de trabajo actual',
        'site.contactPanel.invite': 'Obtener Código de Invitación',
        'site.contactPanel.register': 'Registrarse Ahora',
        'site.contactPanel.login': 'Ir a Iniciar Sesión',
        'site.contactModal.title': 'Contáctenos',
        'site.contactModal.label.name': 'Nombre',
        'site.contactModal.label.email': 'Correo de Contacto',
        'site.contactModal.label.phone': 'Teléfono',
        'site.contactModal.label.subject': 'Asunto',
        'site.contactModal.label.content': 'Mensaje',
        'site.contactModal.placeholder.name': 'Su Nombre',
        'site.contactModal.placeholder.email': 'Correo de Contacto',
        'site.contactModal.placeholder.phone': 'Teléfono (Opcional)',
        'site.contactModal.placeholder.subject': 'Por favor, seleccione un asunto',
        'site.contactModal.placeholder.content': 'Por favor, ingrese su mensaje',
        'site.contactModal.rule.name': 'Por favor, ingrese su nombre',
        'site.contactModal.rule.email': 'Por favor, ingrese su correo electrónico',
        'site.contactModal.rule.emailType': 'Por favor, ingrese una dirección de correo válida',
        'site.contactModal.rule.subject': 'Por favor, seleccione un asunto',
        'site.contactModal.rule.content': 'Por favor, ingrese su mensaje',
        'site.contactModal.subject.product': 'Consulta de Producto',
        'site.contactModal.subject.cooperation': 'Colaboración',
        'site.contactModal.subject.tech': 'Problema Técnico',
        'site.contactModal.subject.feedback': 'Comentarios',
        'site.contactModal.subject.other': 'Otro',
        'site.contactModal.okText': 'Enviar',
        'site.contactModal.cancelText': 'Cancelar',
        'site.contactModal.success': 'Enviado con éxito. Nos pondremos en contacto pronto.',
        'site.contactModal.fail': 'Error al enviar. Inténtelo de nuevo más tarde.',
        'site.waitlistModal.title': 'Obtener un Código de Invitación',
        'site.waitlistModal.placeholder.name': 'Su Nombre',
        'site.waitlistModal.placeholder.email': 'Correo de Contacto',
        'site.waitlistModal.placeholder.direction': 'Área de Interés',
        'site.waitlistModal.rule.name': 'Por favor, ingrese su nombre',
        'site.waitlistModal.rule.email': 'Por favor, ingrese una dirección de correo válida',
        'site.waitlistModal.rule.emailType': 'Por favor, ingrese una dirección de correo válida',
        'site.waitlistModal.rule.direction': 'Por favor, seleccione un área de interés',
        'site.waitlistModal.okText': 'Enviar Solicitud',
        'site.waitlistModal.cancelText': 'Cancelar',
        'site.waitlistModal.success': 'Solicitud enviada. Nos pondremos en contacto pronto.',
        'site.waitlistModal.fail': 'Error al enviar. Inténtelo de nuevo más tarde.',
        'site.waitlistModal.direction.assist': 'Trading Asistido por IA',
        'site.waitlistModal.direction.auto': 'Trading Automatizado',
        'site.waitlistModal.direction.asset': 'Gestión de Activos',
        'site.waitlistModal.direction.risk': 'Control de Riesgos',
        'site.waitlistModal.direction.other': 'Otro',
        'auth.login.actionHome': 'Volver al Sitio Web',
        'auth.login.eyebrow': 'Estación de Trading',
        'auth.login.title': 'Inicie sesión en su cuenta de D-Sense',
        'auth.login.panelTitle': 'Bienvenido de nuevo',
        'auth.login.description': 'Consulte el rendimiento de su estrategia, resumen de activos e historial de ejecución después de iniciar sesión.',
        'auth.login.footnote': '¿Ya tiene una cuenta? Inicie sesión. ¿Aún no tiene un código de invitación?',
        'auth.login.cardTitle': 'Inicio de Sesión',
        'auth.login.cardDescription': 'Inicie sesión para continuar usando D-Sense.',
        'auth.login.usernameRequired': 'Por favor, ingrese su nombre de usuario',
        'auth.login.passwordRequired': 'Por favor, ingrese su contraseña',
        'auth.login.passwordMin': 'La contraseña debe tener al menos 6 caracteres.',
        'auth.login.usernamePlaceholder': 'Nombre de usuario',
        'auth.login.passwordPlaceholder': 'Contraseña',
        'auth.login.submit': 'Iniciar Sesión',
        'auth.login.noAccount': '¿Aún no tiene cuenta?',
        'auth.login.register': 'Registro con invitación',
        'auth.login.getInvite': 'Obtener código de invitación',
        'auth.login.alreadyLoggedIn': 'Sesión iniciada como',
        'auth.login.enterSystem': 'Entrar al sistema',
        'auth.login.highlight.1.title': 'Gestión de activos de nueva generación',
        'auth.login.highlight.1.description': 'Inicie sesión para activar la gestión de activos con IA',
        'auth.login.highlight.2.title': 'Estamos realizando una prueba piloto',
        'auth.login.highlight.2.description': 'Inicie sesión y comience su viaje de trading',
        'auth.login.highlight.3.title': 'Advertencia de Riesgo',
        'auth.login.highlight.3.description': 'D-Sense es un gestor de activos con IA y no promete ningún rendimiento.',
        'auth.register.actionPoc': 'Ver POC',
        'auth.register.eyebrow': 'Comenzar',
        'auth.register.title': 'Cree su cuenta de D-Sense',
        'auth.register.description': 'Ingrese su código de invitación y datos de la cuenta para comenzar.',
        'auth.register.footnote': '¿Tiene un código? Regístrese ahora. ¿Necesita uno? Solicite acceso primero.',
        'auth.register.cardTitle': 'Registro con Invitación',
        'auth.register.cardDescription': 'Ingrese un código de invitación válido para crear su cuenta.',
        'auth.register.step.verify': 'Verificar Código',
        'auth.register.step.verifyDescription': 'Ingrese su código de invitación',
        'auth.register.step.create': 'Crear Cuenta',
        'auth.register.step.createDescription': 'Complete los datos de su cuenta',
        'auth.register.enterCode': 'Ingrese su código de invitación',
        'auth.register.codeLabel': 'Código de Invitación',
        'auth.register.codePlaceholder': 'Ingrese el código de invitación',
        'auth.register.codeSubmit': 'Verificar Código de Invitación',
        'auth.register.codeEmpty': 'Por favor, ingrese su código de invitación',
        'auth.register.codeFailed': 'Verificación fallida. Inténtelo de nuevo más tarde.',
        'auth.register.usernameRequired': 'Por favor, ingrese su nombre de usuario',
        'auth.register.usernameMin': 'El nombre de usuario debe tener al menos 3 caracteres.',
        'auth.register.usernameMax': 'El nombre de usuario debe tener como máximo 50 caracteres.',
        'auth.register.usernamePlaceholder': 'Nombre de usuario (3-50 caracteres)',
        'auth.register.emailRequired': 'Por favor, ingrese su correo electrónico',
        'auth.register.emailInvalid': 'Por favor, ingrese una dirección de correo válida',
        'auth.register.emailPlaceholder': 'Correo electrónico',
        'auth.register.passwordRequired': 'Por favor, ingrese su contraseña',
        'auth.register.passwordMin': 'La contraseña debe tener al menos 6 caracteres.',
        'auth.register.passwordPlaceholder': 'Contraseña (al menos 6 caracteres)',
        'auth.register.confirmRequired': 'Por favor, confirme su contraseña',
        'auth.register.confirmPlaceholder': 'Confirmar contraseña',
        'auth.register.confirmMismatch': 'Las contraseñas ingresadas no coinciden.',
        'auth.register.previous': 'Anterior',
        'auth.register.submit': 'Registrarse',
        'auth.register.existing': '¿Ya tiene una cuenta?',
        'auth.register.login': 'Iniciar sesión',
        'auth.register.getInvite': 'Obtener código de invitación',
        'auth.register.currentCode': 'Código de Invitación',
        'auth.register.highlight.1.title': 'Comience con un código válido',
        'auth.register.highlight.1.description': 'Ingrese su código de invitación para comenzar el registro.',
        'auth.register.highlight.2.title': 'Un proceso de registro más directo',
        'auth.register.highlight.2.description': 'Verifique primero, luego cree su cuenta.',
        'auth.register.highlight.3.title': 'Solicite acceso si lo necesita',
        'auth.register.highlight.3.description': 'Si aún no tiene un código, envíe su información primero.'
    }
};

export const antdLocaleMap = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en-US': enUS,
    'ko-KR': koKR,
    'ja-JP': jaJP,
    'fr-FR': frFR,
    'es-ES': esES
};
